import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';

//utils
import queries from '../../utils/queries'

import HomeCar1 from './homecar1';
import HomeCar2 from './homecar2';

import ConfMetodo1 from './carta/confmetodo1';
import ConfMetodo2 from './carta/confmetodo2';
import AddMetodo1 from './carta/addmetodo1';
import AddMetodo2 from './carta/addmetodo2';
import VerMetodo1 from './carta/vermetodo1';
import VerMetodo2 from './carta/vermetodo2';

import ConfTarea1 from './carta/conftarea1';
import ConfTarea2 from './carta/conftarea2';
import AddTarea1 from './carta/addtarea1';
import AddTarea2 from './carta/addtarea2';
import VerTarea1 from './carta/vertarea1';
import VerTarea2 from './carta/vertarea2';

import ConfFrecuencia1 from './carta/conffrecuencia1';
import ConfFrecuencia2 from './carta/conffrecuencia2';
import AddFrecuencia1 from './carta/addfrecuencia1';
import AddFrecuencia2 from './carta/addfrecuencia2';
import VerFrecuencia1 from './carta/verfrecuencia1';
import VerFrecuencia2 from './carta/verfrecuencia2';

import ConfAplicacion1 from './carta/confaplicacion1';
import ConfAplicacion2 from './carta/confaplicacion2';
import AddAplicacion1 from './carta/addaplicacion1';
import AddAplicacion2 from './carta/addaplicacion2';
import VerAplicacion1 from './carta/veraplicacion1';
import VerAplicacion2 from './carta/veraplicacion2';

import ConfGrado1 from './carta/confgrado1';
import ConfGrado2 from './carta/confgrado2';
import AddGrado1 from './carta/addgrado1';
import AddGrado2 from './carta/addgrado2';
import VerGrado1 from './carta/vergrado1';
import VerGrado2 from './carta/vergrado2';

import ConfLubricante1 from './carta/conflubricante1';
import ConfLubricante2 from './carta/conflubricante2';
import AddLubricante1 from './carta/addlubricante1';
import AddLubricante2 from './carta/addlubricante2';
import VerLubricante1 from './carta/verlubricante1';
import VerLubricante2 from './carta/verlubricante2';

import ConfProcEjec1 from './carta/confprocejec1';
import ConfProcEjec2 from './carta/confprocejec2';
import AddProcEjec1 from './carta/addprocejec1';
import AddProcEjec2 from './carta/addprocejec2';
import VerProcEjec1 from './carta/verprocejec1';
import VerProcEjec2 from './carta/verprocejec2';

import ConfInfoTarea1 from './carta/confinfotarea1';
import ConfInfoTarea2 from './carta/confinfotarea2';
import AddInfoTarea1 from './carta/addinfotarea1';
import AddInfoTarea2 from './carta/addinfotarea2';
import VerInfoTarea1 from './carta/verinfotarea1';
import VerInfoTarea2 from './carta/verinfotarea2';

import ConfDatCar1 from './carta/confdatcar1';
import ConfDatCar2 from './carta/confdatcar2';
import VerDatCar1 from './carta/verdatcar1';
import VerDatCar2 from './carta/verdatcar2';

import ConfSimRot1 from './carta/confsimrot1';
import ConfSimRot2 from './carta/confsimrot2';

import ConfGenRot1 from './carta/confgenrot1';
import ConfGenRot2 from './carta/confgenrot2';

import ConfAsImEq1 from './carta/confasimeq1';
import ConfAsImEq2 from './carta/confasimeq2';
import ConfAsImSecc1 from './carta/confasimsecc1';
import ConfAsImSecc2 from './carta/confasimsecc2';

import ConfImprCL1 from './carta/confimprcl1';
import ConfImprCL2 from './carta/confimprcl2';
import CarAnexos1 from './carta/caranexos1';
import CarAnexos2 from './carta/caranexos2';
import CarStockLub1 from './carta/carstocklub1';
import CarStockLub2 from './carta/carstocklub2';
import AddStockLub1 from './carta/addstocklub1';
import AddStockLub2 from './carta/addstocklub2';
import VerStockLub1 from './carta/verstocklub1';
import VerStockLub2 from './carta/verstocklub2';
import CarPdfEq1 from './carta/carpdfeq1';
import CarPdfEq2 from './carta/carpdfeq2';

function getNumDiasMes(mesDias, agnoDias){
  /*
      Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
      Los meses 4,6,9,11 siempre tienen 30 días
      El mes de febrero dependiendo del año puede tener 28 o 29 días
  */
  let mes = parseInt(mesDias, 10)
  let agno = parseInt(agnoDias, 10)

  if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
    return 31;
  else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
    return 30;
  else if( mes === 2 )
  {
      if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
        return 29;
      else
        return 28;
  }   
}

class HomeCar extends React.Component{
  state={
    showCar: true, 
    showMetodo: false, addMetodo: false, verMetodo: false,
    showTarea: false, addTarea: false, verTarea: false,
    showFrecuencia: false, addFrecuencia: false, verFrecuencia: false,
    showAplicacion: false, addAplicacion: false, verAplicacion: false,
    showGrado: false, addGrado: false, verGrado: false,
    showLubricante: false, addLubricante: false, verLubricante: false,
    showStockLub: false, addStockLub: false, verStockLub: false,
    showProcEjec: false, addProcEjec: false, verProcEjec: false,
    showInfoTarea: false, addInfoTarea: false, verInfoTarea: false,
    showDatCar: false, verDatCar: false, showSimRot: false, showGenRot: false, 
    showAsImEq: false, showAsImSecc: false, showImprCL: false, showAnexos: false, showPdfEq: false,
    permiteUpdate: false, permiteDelete: false,
    permiteClose: false, argsAdd: {}, errorAdd: [],
    argsBuscEstruct: {descrEmpresa: localStorage.getItem('Empresa')==="Todas..."?"Seleccionar Empresa...":localStorage.getItem('Empresa')},
    idLista: {}, argsBuscar: {}, argsBuscGrado: {}, argsBuscStock: {}, argsBuscLub: {},
    argsQuery: `{"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {"$unwind": "$secciones.equipos.componentes"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos"},
      {$project: {idPlanta: '$_id', descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
        descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
        descrEquipo: '$secciones.equipos.descrEquipo', codComponente: '$secciones.equipos.componentes.codComponente',
        descrComponente: '$secciones.equipos.componentes.descrComponente',
        codMecanismo: '$secciones.equipos.componentes.mecanismos.codMecanismo',
        descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
        descrFabricante: '$secciones.equipos.componentes.mecanismos.descrFabricante',
        descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
        categoriaLub: '$secciones.equipos.componentes.mecanismos.categoriaLub',
        tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
        tipoGrado: '$secciones.equipos.componentes.mecanismos.tipoGrado',
        descrGrado: '$secciones.equipos.componentes.mecanismos.descrGrado',
        colorTexto: '$secciones.equipos.componentes.mecanismos.colorTexto',
        isoGrasa: '$secciones.equipos.componentes.mecanismos.isoGrasa',
        isoGrasaColor: '$secciones.equipos.componentes.mecanismos.isoGrasaColor',
        isoGrasaTexto: '$secciones.equipos.componentes.mecanismos.isoGrasaTexto',        
        descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion',
        tipoFrecuencia: '$secciones.equipos.componentes.mecanismos.tipoFrecuencia',
        abrevUnidadTF: '$secciones.equipos.componentes.mecanismos.abrevUnidadTF',
        cantidadTotal: '$secciones.equipos.componentes.mecanismos.cantidadTotal',
        descrUnidad: '$secciones.equipos.componentes.mecanismos.descrUnidad',
        abrevUnidad: '$secciones.equipos.componentes.mecanismos.abrevUnidad',
        codigoQR: '$secciones.equipos.componentes.mecanismos.codigoQR'}}`,
    argsQuery1: `{"$unwind": "$secciones"},
      {"$unwind": "$secciones.equipos"},
      {"$unwind": "$secciones.equipos.componentes"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos"},
      {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"},
      {$project: {_id: 1, idPlanta: "$_id",
        descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
        descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
        descrEquipo: '$secciones.equipos.descrEquipo',
        numCarta: '$secciones.equipos.numCarta',
        imagenes: '$secciones.equipos.imagenes',
        codComponente: '$secciones.equipos.componentes.codComponente',
        descrComponente: '$secciones.equipos.componentes.descrComponente',
        codMecanismo: '$secciones.equipos.componentes.mecanismos.codMecanismo',
        descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
        claseLub: '$secciones.equipos.componentes.mecanismos.claseLub',
        descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion',
        colorAplicacion: '$secciones.equipos.componentes.mecanismos.colorAplicacion',
        descrFabricante: '$secciones.equipos.componentes.mecanismos.descrFabricante',
        descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
        tipoFrecuencia: '$secciones.equipos.componentes.mecanismos.tipoFrecuencia',
        categoriaLub: '$secciones.equipos.componentes.mecanismos.categoriaLub',
        tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
        descrGrado: '$secciones.equipos.componentes.mecanismos.descrGrado',
        colorTexto: '$secciones.equipos.componentes.mecanismos.colorTexto',
        tipoGrado: '$secciones.equipos.componentes.mecanismos.tipoGrado',
        apiSAE: '$secciones.equipos.componentes.mecanismos.apiSAE',
        colorGrado: '$secciones.equipos.componentes.mecanismos.colorGrado',
        isoGrasa: '$secciones.equipos.componentes.mecanismos.isoGrasa',
        isoGrasaColor: '$secciones.equipos.componentes.mecanismos.isoGrasaColor',
        isoGrasaTexto: '$secciones.equipos.componentes.mecanismos.isoGrasaTexto',                
        abrevUnidadTF: '$secciones.equipos.componentes.mecanismos.abrevUnidadTF',
        cantidadTotal: '$secciones.equipos.componentes.mecanismos.cantidadTotal',
        descrUnidad: '$secciones.equipos.componentes.mecanismos.descrUnidad',
        abrevUnidad: '$secciones.equipos.componentes.mecanismos.abrevUnidad',
        codigoQR: '$secciones.equipos.componentes.mecanismos.codigoQR',
        cantidad: '$secciones.equipos.componentes.mecanismos.programacion.cantidad',
        consecutivo:{$cond: { 
          if: { $gt: [ '$secciones.equipos.componentes.mecanismos.programacion.consecutivo', '' ] },
            then: {$toInt: '$secciones.equipos.componentes.mecanismos.programacion.consecutivo'}, else: {$toInt: 0}
          }
        },
        puntosLub: '$secciones.equipos.componentes.mecanismos.programacion.puntosLub',
        descrMetodo: '$secciones.equipos.componentes.mecanismos.programacion.descrMetodo',
        descrTarea: '$secciones.equipos.componentes.mecanismos.programacion.descrTarea',
        modoTarea: '$secciones.equipos.componentes.mecanismos.programacion.modoTarea',
        requiereSISO: '$secciones.equipos.componentes.mecanismos.programacion.requiereSISO',
        codProcedimiento: '$secciones.equipos.componentes.mecanismos.programacion.codProcedimiento',
        nombreArchivo: '$secciones.equipos.componentes.mecanismos.programacion.nombreArchivo',
        descrFrecuencia: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuencia',
        archRotulo: '$secciones.equipos.componentes.mecanismos.programacion.archRotulo'}},
    {$lookup: {from: 'rotulos', localField: 'archRotulo', foreignField: 'descrRotulo', as: 'rotulo'}},
    {$unwind: '$rotulo'},
    {$project: {_id: 1, idPlanta: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, 
        descrEquipo: 1, descrComponente: 1, descrMecanismo: 1,
        categoriaLub: 1, claseLub: 1, colorAplicacion: 1, descrAplicacion: 1, tipoLub: 1, 
        descrLubricante: 1, colorGrado: 1, tipoGrado: 1, descrGrado: 1, isoGrasaColor: 1, 
        isoGrasaTexto: 1, colorTexto: 1, apiSAE: 1, descrMetodo: 1, descrTarea: 1, modoTarea: 1, requiereSISO: 1, descrFrecuencia: 1,
        nombreArchivo: 1, codProcedimiento: 1, puntosLub: 1, cantidad: 1, codigoQR: 1, abrevUnidad: 1, 
        descrUnidad: 1, cantidadTotal: 1, abrevUnidadTF: 1, tipoFrecuencia: 1, descrFabricante: 1, 
        codPlanta: 1, codSeccion: 1, codEquipo: 1, codComponente: 1, codMecanismo: 1, consecutivo: 1,
        numCarta: 1, imagenes: 1, archRotulo: '$rotulo.archRotulo'}},
      {$sort: {descrPlanta: 1, numCarta: 1, consecutivo: 1}}`,
    argsQuery2: `{"$unwind": "$secciones"},
    {"$unwind": "$secciones.equipos"},
    {$project: {_id: 1, idPlanta: "$_id",
        imagenes: {
          $let: {
             vars: {regProg: { $cond: { if: { $isArray: "$secciones.equipos.imagenes" },
                                          then: { $size: "$secciones.equipos.imagenes" },
                                          else: 0} }
             },
             in: { $cond: { if: { $gt: [ "$$regProg", 0 ] },
                                 then: "$secciones.equipos.imagenes",
                                 else: [{nombreImagen: null, archImagen: null, anchoImagen: null, altoImagen: null,
                                          ordenImagen: null}] } }
        }},
      descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
      descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
      descrEquipo: '$secciones.equipos.descrEquipo',
      numCarta: '$secciones.equipos.numCarta'}},
    {"$unwind": "$imagenes"},
    {$project: {_id: 1, idPlanta: 1, descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: 1, descrSeccion: 1,
      codEquipo: 1, descrEquipo: 1, numCarta: 1,
      nombreImagen: '$imagenes.nombreImagen', archImagen: '$imagenes.archImagen',
      anchoImagen: '$imagenes.anchoImagen', altoImagen: '$imagenes.altoImagen', 
      ordenImagen:{$cond: { 
        if: { $gt: [ '$imagenes.ordenImagen', 0 ] },
          then: {$toInt: '$imagenes.ordenImagen'}, else: {$toInt: 0}
        }
      }
    }},
    {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, ordenImagen: 1}}`,
    argsQuery6: `{"$unwind": "$secciones"},
    {$project: {_id: 1, idPlanta: "$_id",
        imagen: {
          $let: {
             vars: {regImg: { $cond: { if: { $isArray: "$secciones.imagen" },
                                          then: { $size: "$secciones.imagen" },
                                          else: 0} }
             },
             in: { $cond: { if: { $gt: [ "$$regImg", 0 ] },
                                 then: "$secciones.imagen",
                                 else: [{nombre: null, archivo: null}] } }
        }},
      descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
      descrSeccion: '$secciones.descrSeccion'}},
    {"$unwind": "$imagen"},
    {$project: {_id: 1, idPlanta: 1, descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: 1, descrSeccion: 1,
      nombre: '$imagen.nombre', archivo: '$imagen.archivo'
    }},
    {$sort: {descrPlanta: 1, descrSeccion: 1}}`,
    argsQuery3: `{"$unwind": "$secciones"}, 
    {"$unwind": "$secciones.equipos"}, 
    {"$unwind": "$secciones.equipos.componentes"}, 
    {"$unwind": "$secciones.equipos.componentes.mecanismos"}, 
    {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"}, 
    {$project: {_id: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: '$secciones.descrSeccion', 
        descrEquipo: '$secciones.equipos.descrEquipo', 
        descrComponente: '$secciones.equipos.componentes.descrComponente',
        descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
        categoriaLub: '$secciones.equipos.componentes.mecanismos.categoriaLub', 
        claseLub: '$secciones.equipos.componentes.mecanismos.claseLub', 
        colorAplicacion: '$secciones.equipos.componentes.mecanismos.colorAplicacion', 
        descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion',
        tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
        descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
        colorGrado: '$secciones.equipos.componentes.mecanismos.colorGrado', 
        tipoGrado: '$secciones.equipos.componentes.mecanismos.tipoGrado',
        descrGrado: '$secciones.equipos.componentes.mecanismos.descrGrado', 
        isoGrasaColor: '$secciones.equipos.componentes.mecanismos.isoGrasaColor', 
        isoGrasaTexto: '$secciones.equipos.componentes.mecanismos.isoGrasaTexto', 
        colorTexto: '$secciones.equipos.componentes.mecanismos.colorTexto', 
        apiSAE: '$secciones.equipos.componentes.mecanismos.apiSAE',
        descrMetodo: '$secciones.equipos.componentes.mecanismos.programacion.descrMetodo',
        descrTarea: '$secciones.equipos.componentes.mecanismos.programacion.descrTarea',
        modoTarea: '$secciones.equipos.componentes.mecanismos.programacion.modoTarea',
        requiereSISO: '$secciones.equipos.componentes.mecanismos.programacion.requiereSISO',
        descrFrecuencia: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuencia',
        archRotulo: '$secciones.equipos.componentes.mecanismos.programacion.archRotulo'}},
        {$lookup: {from: 'rotulos', localField: 'archRotulo', foreignField: 'descrRotulo', as: 'rotulo'}},
        {$unwind: '$rotulo'},
        {$project: {_id: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1, descrMecanismo: 1,
          categoriaLub: 1, claseLub: 1, colorAplicacion: 1, descrAplicacion: 1, tipoLub: 1, descrLubricante: 1, colorGrado: 1, tipoGrado: 1,
          descrGrado: 1, isoGrasaColor: 1, isoGrasaTexto: 1, colorTexto: 1, apiSAE: 1, descrMetodo: 1, descrTarea: 1, modoTarea: 1, requiereSISO: 1, descrFrecuencia: 1,
          archRotulo: '$rotulo.archRotulo'}}`,
    argsQuery4: `{"$unwind": "$secciones"}, 
    {"$unwind": "$secciones.equipos"}, 
    {"$unwind": "$secciones.equipos.componentes"}, 
    {"$unwind": "$secciones.equipos.componentes.mecanismos"}, 
    {"$unwind": "$secciones.equipos.componentes.mecanismos.programacion"}, 
    {$project: {_id: 1, descrEmpresa: 1, descrPlanta: 1, descrSeccion: '$secciones.descrSeccion', 
        descrEquipo: '$secciones.equipos.descrEquipo', 
        descrComponente: '$secciones.equipos.componentes.descrComponente',
        descrMecanismo: '$secciones.equipos.componentes.mecanismos.descrMecanismo',
        categoriaLub: '$secciones.equipos.componentes.mecanismos.categoriaLub', 
        claseLub: '$secciones.equipos.componentes.mecanismos.claseLub', 
        colorAplicacion: '$secciones.equipos.componentes.mecanismos.colorAplicacion', 
        descrAplicacion: '$secciones.equipos.componentes.mecanismos.descrAplicacion',
        tipoLub: '$secciones.equipos.componentes.mecanismos.tipoLub',
        descrLubricante: '$secciones.equipos.componentes.mecanismos.descrLubricante',
        colorGrado: '$secciones.equipos.componentes.mecanismos.colorGrado', 
        tipoGrado: '$secciones.equipos.componentes.mecanismos.tipoGrado',
        descrGrado: '$secciones.equipos.componentes.mecanismos.descrGrado', 
        isoGrasaColor: '$secciones.equipos.componentes.mecanismos.isoGrasaColor', 
        isoGrasaTexto: '$secciones.equipos.componentes.mecanismos.isoGrasaTexto', 
        colorTexto: '$secciones.equipos.componentes.mecanismos.colorTexto', 
        apiSAE: '$secciones.equipos.componentes.mecanismos.apiSAE',
        descrMetodo: '$secciones.equipos.componentes.mecanismos.programacion.descrMetodo',
        descrTarea: '$secciones.equipos.componentes.mecanismos.programacion.descrTarea',
        modoTarea: '$secciones.equipos.componentes.mecanismos.programacion.modoTarea',
        requiereSISO: '$secciones.equipos.componentes.mecanismos.programacion.requiereSISO',
        descrFrecuencia: '$secciones.equipos.componentes.mecanismos.programacion.descrFrecuencia',
        archRotulo: '$secciones.equipos.componentes.mecanismos.programacion.archRotulo'}}`,
    argsQuery5: `{"$unwind": "$inventario"},
      {$project: {_id: 1, descrLubricante: 1, 
          descrEmpresa: '$inventario.descrEmpresa'}}`
  }
  
    crudBD = async (operacionCRUD, args, i)=>{
    //ACTUALIZAR BD
    if(args.ctrlCampo === 'CRUD'){
      const {data} = await operacionCRUD({
        variables: args
      });

//Se utiliza para traer el _id del documento creado
      if(args.ctrl_id === 'SI_ID'){
        if(Object.values(data)[0]._id){
          return Object.values(data)[0]._id
        }else{
          return 0
        }
      }
    }else{
      if(args.ctrlCampo === "MANY"){
        await operacionCRUD({
          variables: args
        });
      }
    }
  }
    
  updColecc = async (crudColecc, argsCrud, totDocCRUD)=>{
//ENVIO PARA ACTUALIZAR BD
    let codigo = 0
    if(argsCrud[0].ctrl_id === 'SI_ID'){
      codigo = await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }else{
      await this.crudBD(crudColecc[0], argsCrud[0], 0)
    }
    if(codigo!==0){
      for(let i=1; i<totDocCRUD; i++){
        argsCrud[i]._id = codigo
      }
    }
    for(let i=1; i<totDocCRUD; i++){
      await this.crudBD(crudColecc[i], argsCrud[i], i)
    }
  }

  handleChangeBuscLub = (ev)=>{
    const argsBuscar = this.state.argsBuscar
    argsBuscar[ev.target.name] = ev.target.value
    this.setState({argsBuscar})
    this.handleBuscLub(argsBuscar)
  }
  handleBuscLub = async (args) => {
    let argsBuscar={} 
    if(args.descrFabricante){
      argsBuscar.descrFabricante=args.descrFabricante
    }else{
      delete argsBuscar.descrFabricante
    }
    if(args.descrLubricante){
      argsBuscar.descrLubricante=args.descrLubricante
    }else{
      delete argsBuscar.descrLubricante
    }
    this.setState({argsBuscLub: argsBuscar});
  }

  handleUpdAsImEq = async (ev, idListaP)=>{
    let listImg = ev.target.files

    if(idListaP.descrEquipo){
      let numImgAsoc = 0

      let validImg = []
      for(let ii=0; ii<listImg.length; ii++){
        //VALIDAR SI EL ARCHIVO EXISTE (ESTA EN LA CARPETA => NO SE COPIA)
        let argsBuscar = {}
        argsBuscar = `'descrEmpresa': '${idListaP.descrEmpresa}', 'nombreImagen': '${listImg[ii].name}'`
        let argsBuscarPl = {}
        let argsQuery = `{"$unwind": "$secciones"},
          {"$unwind": "$secciones.equipos"},
          {"$unwind": "$secciones.equipos.imagenes"},
          {$project: {idPlanta: '$_id', descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
            descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
            descrEquipo: '$secciones.equipos.descrEquipo', nombreImagen: '$secciones.equipos.imagenes.nombreImagen'}}`
        argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}}]`}
        let regExisteArch = [], regExiste = 0

        if(this.props.allPlantaRtes1.allPlantaRtes){
          let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
          regExisteArch = await data.allPlantaRtes

          for(let iii=0; iii<regExisteArch.length; iii++){
            if(regExisteArch[iii].descrEmpresa===idListaP.descrEmpresa&&
                  regExisteArch[iii].descrPlanta===idListaP.descrPlanta&&
                  regExisteArch[iii].descrSeccion===idListaP.descrSeccion&&
                  regExisteArch[iii].descrEquipo===idListaP.descrEquipo){
              regExiste = 1
            }
          }
        }

        //VALIDAR SI LA IMAGEN YA ESTA ASOCIADA

        validImg.push({name: listImg[ii].name, existe: regExiste, existeArch: regExisteArch.length})
        if(regExiste===0){
          numImgAsoc += 1
        }
      }

      if(numImgAsoc>0){
        document.body.style.cursor = 'wait'
      }

      let file = ""
      //Se define el ancho y alto de la imagen (entre mas grande mejor resolucion)
      // let ancho = 800
      // let alto = 532
      for(let ii=0; ii<listImg.length; ii++){
        if(validImg[ii].existe===0){
          file = listImg[ii]

          //COPIA EL ARCHIVO EN LA CARPETA DEL SERVIDOR './slcm-client/public/images/cartas'
          let archCopiado = ""
          if(validImg[ii].existeArch===0){
            let response = await this.props.singleUpload({variables: {file}});
            archCopiado = response.data.singleUpload.filename
          }{
          }

          //PROCESO PARA GUARDAR LA IMAGEN EN LA BASE DE DATOS
          const updState = async (data, name, nuevoAncho, nuevoAlto) => {
            let response = await this.props.fecha({
              variables: {}
            });
            const {fechaHoraHoy} = response.data.fecha 

            let addColeccPl = []

            let argsImagen = {}, addColeccImg = []
            let argsEqu = {}, addColeccEqu = []
            let argsSecc = {}, addColeccSecc = []
            let argsPl = {}
            //IMAGEN NUEVA

            argsImagen['nombreImagen'] = name
            argsImagen['archImagen'] = data
            argsImagen['anchoImagen'] = nuevoAncho
            argsImagen['altoImagen'] = nuevoAlto
            argsImagen['fechaCreate'] = fechaHoraHoy
            argsImagen['usuarioCreate'] = localStorage.getItem('userLogin')

            addColeccImg.push(argsImagen)

            argsEqu['descrEquipo'] = idListaP.descrEquipo
            argsEqu['imagenes'] = addColeccImg
            addColeccEqu.push(argsEqu)
            argsSecc['descrSeccion'] = idListaP.descrSeccion
            argsSecc['equipos'] = addColeccEqu
            addColeccSecc.push(argsSecc)
            argsPl['secciones'] = addColeccSecc

            argsPl['descrEmpresa'] = idListaP.descrEmpresa
            argsPl['_id'] = idListaP.idPlanta
            argsPl['descrPlanta'] = idListaP.descrPlanta
            if(archCopiado){
              argsPl['descrComponente'] = archCopiado
            }else{
              argsPl['descrComponente'] = ""
            }
            argsPl['descrComponenteAnt'] = idListaP.descrEmpresa.replace(/\./g,'') //quitar puntos
            argsPl['tipoAct'] = "CrearImagen"
            addColeccPl.push(argsPl) 
          
            let addColeccImg1 = []
            addColeccImg = []
            for(let iii=0; iii<addColeccPl.length; iii++){
              addColeccImg.push(addColeccPl[iii])
            }
            addColeccImg1.push({planta: addColeccImg})
            let numDocCRUD = 0
            let totDocCRUD = 1
            let argsCrud = []
            let crudColecc = []
            for(let iii=0; iii<totDocCRUD; iii++){
              argsCrud.push({ctrlCampo: 'NO_CRUD'})
            }
            for(let iii=0; iii<totDocCRUD; iii++){
              crudColecc.push(this.props.editPlantaEstructura)
            }

            argsCrud[numDocCRUD] = addColeccImg1[0]
            argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
            argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
            crudColecc[numDocCRUD] = this.props.editPlantaEstructura

            await this.updColecc(crudColecc, argsCrud, totDocCRUD)
            //FIN IMAGEN NUEVA

            if(ii===listImg.length-1){
              document.body.style.cursor = 'default'
              alert("!! Proceso finalizado !!")

              const argsBuscEstruct = this.state.argsBuscEstruct
              this.setState({argsBuscEstruct});
              this.handleBuscEstruct(argsBuscEstruct)

              document.getElementById("img").value = ""
            }
          }

          let nombreImagen = file.name
          let canvas = document.createElement( "canvas" );
          let ctx = canvas.getContext( "2d" );
          let img = document.createElement( "img" );
          img.src = URL.createObjectURL(file);
          img.setAttribute( "name", nombreImagen );
          img.onload = function() {
            let nuevoAncho = this.width
            let nuevoAlto = this.height
            nuevoAncho = parseInt(nuevoAncho, 10)
            nuevoAlto = parseInt(nuevoAlto, 10)

            let data=""
            updState(data, nombreImagen, nuevoAncho, nuevoAlto)
          }
        //FIN PROCESO PARA GUARDAR LA IMAGEN EN LA BASE DE DATOS

        }else{
          if(ii===listImg.length-1){
            document.body.style.cursor = 'default'
            alert("!! Proceso finalizado !!")

            const argsBuscEstruct = this.state.argsBuscEstruct
            this.setState({argsBuscEstruct});
            this.handleBuscEstruct(argsBuscEstruct)

            document.getElementById("img").value = ""
          }

        }
      }
    }else{
      alert("!! Por favor seleccione el equipo !!")
      document.getElementById("img").value = ""
    }
  }

  handleUpdAsImSecc = async (ev, idListaP)=>{
    let listImg = ev.target.files

    if(idListaP.descrSeccion){
      let numImgAsoc = 0

      let validImg = []
      for(let ii=0; ii<listImg.length; ii++){

        //VALIDAR SI EL ARCHIVO EXISTE (ESTA EN LA CARPETA => NO SE COPIA)
        let argsBuscar = {}
        argsBuscar = `'descrEmpresa': '${idListaP.descrEmpresa}', 'nombre': '${listImg[ii].name}'`
        let argsBuscarPl = {}
        let argsQuery = `{"$unwind": "$secciones"},
          {"$unwind": "$secciones.imagen"},
          {$project: {idPlanta: '$_id', descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
            descrSeccion: '$secciones.descrSeccion', nombre: '$secciones.imagen.nombre'}}`
        argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}}]`}
        let regExisteArch = [], regExiste = 0

        if(this.props.allPlantaRtes1.allPlantaRtes){
          let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
          regExisteArch = await data.allPlantaRtes

          for(let iii=0; iii<regExisteArch.length; iii++){
            if(regExisteArch[iii].descrEmpresa===idListaP.descrEmpresa&&
                  regExisteArch[iii].descrPlanta===idListaP.descrPlanta&&
                  regExisteArch[iii].descrSeccion===idListaP.descrSeccion){
              regExiste = 1
            }
          }
        }

        //VALIDAR SI LA IMAGEN YA ESTA ASOCIADA

        validImg.push({name: listImg[ii].name, existe: regExiste, existeArch: regExisteArch.length})
        if(regExiste===0){
          numImgAsoc += 1
        }
      }

      if(numImgAsoc>0){
        document.body.style.cursor = 'wait'
      }

      let file = ""
      for(let ii=0; ii<listImg.length; ii++){
        if(validImg[ii].existe===0){
          //COPIA EL ARCHIVO EN LA CARPETA DEL SERVIDOR './slcm-client/public/images/cartas'
          let archCopiado = ""
          if(validImg[ii].existeArch===0){
            let response = await this.props.singleUpload({variables: {file: listImg[ii]}}); 
            // let response = await this.props.singleUpload({variables: {file}});
            archCopiado = response.data.singleUpload.filename
          }

          //PROCESO PARA GUARDAR LA IMAGEN EN LA BASE DE DATOS
          let response = await this.props.fecha({
            variables: {}
          });
          const {fechaHoraHoy} = response.data.fecha 

          let addColeccPl = []

          let argsImagen = {}, addColeccImg = []
          let argsEqu = {}, addColeccEqu = []
          let argsSecc = {}, addColeccSecc = []
          let argsPl = {}
          //IMAGEN NUEVA

          argsImagen['nombre'] = listImg[ii].name
          argsImagen['fechaCreate'] = fechaHoraHoy
          argsImagen['usuarioCreate'] = localStorage.getItem('userLogin')

          addColeccImg.push(argsImagen)

          argsSecc['descrSeccion'] = idListaP.descrSeccion
          argsSecc['imagen'] = addColeccImg
          addColeccSecc.push(argsSecc)
          argsPl['secciones'] = addColeccSecc

          argsPl['descrEmpresa'] = idListaP.descrEmpresa
          argsPl['_id'] = idListaP.idPlanta
          argsPl['descrPlanta'] = idListaP.descrPlanta
          if(archCopiado){
            argsPl['descrComponente'] = archCopiado
          }else{
            argsPl['descrComponente'] = ""
          }
          argsPl['descrComponenteAnt'] = idListaP.descrEmpresa.replace(/\./g,'') //quitar puntos
          argsPl['tipoAct'] = "CrearImagenSecc"
          addColeccPl.push(argsPl) 

          let addColeccImg1 = []
          addColeccImg = []
          for(let iii=0; iii<addColeccPl.length; iii++){
            addColeccImg.push(addColeccPl[iii])
          }
          addColeccImg1.push({planta: addColeccImg})
          let numDocCRUD = 0
          let totDocCRUD = 1
          let argsCrud = []
          let crudColecc = []
          for(let iii=0; iii<totDocCRUD; iii++){
            argsCrud.push({ctrlCampo: 'NO_CRUD'})
          }
          for(let iii=0; iii<totDocCRUD; iii++){
            crudColecc.push(this.props.editPlantaEstructura)
          }

          argsCrud[numDocCRUD] = addColeccImg1[0]
          argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
          argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
          crudColecc[numDocCRUD] = this.props.editPlantaEstructura

          await this.updColecc(crudColecc, argsCrud, totDocCRUD)
          //FIN IMAGEN NUEVA

          if(ii===listImg.length-1){
            document.body.style.cursor = 'default'
            alert("!! Proceso finalizado !!")

            const argsBuscEstruct = this.state.argsBuscEstruct
            this.setState({argsBuscEstruct});
            this.handleBuscEstruct(argsBuscEstruct)

            document.getElementById("img").value = ""
          }
        }

          
        //FIN PROCESO PARA GUARDAR LA IMAGEN EN LA BASE DE DATOS
      }
    }else{
      alert("!! Por favor seleccione el equipo !!")
      document.getElementById("img").value = ""
    }
  }

  handleElimAsImEq = async (ev, idListaP)=>{

    if(idListaP.descrEquipo){
      //VALIDAR SI EL ARCHIVO ESTA ASOCIADO VARIAS VECES => NO SE COPIA
      let argsBuscar = {}
      argsBuscar = `'descrEmpresa': '${idListaP.descrEmpresa}', 'nombreImagen': '${idListaP.nombreImagen}'`
      let argsBuscarPl = {}
      let argsQuery = `{"$unwind": "$secciones"},
        {"$unwind": "$secciones.equipos"},
        {"$unwind": "$secciones.equipos.imagenes"},
        {$project: {idPlanta: '$_id', descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
          descrSeccion: '$secciones.descrSeccion', codEquipo: '$secciones.equipos.codEquipo',
          descrEquipo: '$secciones.equipos.descrEquipo', nombreImagen: '$secciones.equipos.imagenes.nombreImagen'}}`
      argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}}]`}
      let regExisteArch = []

      if(this.props.allPlantaRtes1.allPlantaRtes){
        let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
        regExisteArch = await data.allPlantaRtes
      }
      let descrComponenteAnt = ""
      if(regExisteArch.length===1){
        //Esta asociado una sola vez => se puede eliminar de la carpeta
        // descrComponenteAnt = idListaP.descrEmpresa.replace(/^\s+|\s+/g, '') //quitar espacios
        descrComponenteAnt = idListaP.descrEmpresa.replace(/\./g,'') //quitar puntos
        // descrComponenteAnt = idListaP.descrEmpresa
      }
      const argsUpd = {
        descrEmpresa: idListaP.descrEmpresa,
        descrPlanta: idListaP.descrPlanta,
        descrSeccion: idListaP.descrSeccion,
        descrEquipo: idListaP.descrEquipo,
        nombreImagen: idListaP.nombreImagen,
        descrComponenteAnt: descrComponenteAnt
      }
      argsUpd.tipoAct = "EliminarImagen"
      await this.props.editPlantaUpdSeccion({variables: argsUpd});

      const argsBuscEstruct = this.state.argsBuscEstruct
      this.setState({argsBuscEstruct});
      this.handleBuscEstruct(argsBuscEstruct)
    }else{
      alert("!! Por favor seleccione el equipo !!")
    }
  }

  handleElimAsImSecc = async (ev, idListaP)=>{

    if(idListaP.descrSeccion){
      //VALIDAR SI EL ARCHIVO ESTA ASOCIADO VARIAS VECES => NO SE COPIA
      let argsBuscar = {}
      argsBuscar = `'descrEmpresa': '${idListaP.descrEmpresa}', 'nombre': '${idListaP.nombre}'`
      let argsBuscarPl = {}
      let argsQuery = `{"$unwind": "$secciones"},
        {"$unwind": "$secciones.imagen"},
        {$project: {idPlanta: '$_id', descrEmpresa: 1, codPlanta:1, descrPlanta: 1, codSeccion: '$secciones.codSeccion',
          descrSeccion: '$secciones.descrSeccion', nombre: '$secciones.imagen.nombre'}}`
      argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}}]`}
      let regExisteArch = []

      if(this.props.allPlantaRtes1.allPlantaRtes){
        let {data} = await this.props.allPlantaRtes1.refetch(argsBuscarPl)
        regExisteArch = await data.allPlantaRtes
      }
      let descrComponenteAnt = ""
      if(regExisteArch.length===1){
        //Esta asociado una sola vez => se puede eliminar de la carpeta
        descrComponenteAnt = idListaP.descrEmpresa.replace(/\./g,'') //quitar puntos
      }
      const argsUpd = {
        descrEmpresa: idListaP.descrEmpresa,
        descrPlanta: idListaP.descrPlanta,
        descrSeccion: idListaP.descrSeccion,
        nombre: idListaP.nombre,
        descrComponenteAnt: descrComponenteAnt
      }
      argsUpd.tipoAct = "EliminarImagenSecc"
      await this.props.editPlantaUpdSeccion({variables: argsUpd});

      const argsBuscEstruct = this.state.argsBuscEstruct
      this.setState({argsBuscEstruct});
      this.handleBuscEstruct(argsBuscEstruct)
    }else{
      alert("!! Por favor seleccione la sección !!")
    }
  }

  handleChangeBuscEstruct = (ev)=>{
    const argsBuscEstruct = this.state.argsBuscEstruct
    if(ev.target.name === "numDocum"){
      var numDocum = document.getElementById("numDocum");
      if(ev.target.value<=0){
        numDocum.value = ""
        argsBuscEstruct[ev.target.name] = ""
      }else{
        argsBuscEstruct[ev.target.name] = ev.target.value
      }
    }else{
      argsBuscEstruct[ev.target.name] = ev.target.value
    }
    this.setState({argsBuscEstruct});
    this.handleBuscEstruct(argsBuscEstruct)
  }

  handleBuscEstruct = async (argsBuscEstruct) => {
    let argsBuscar={}
    argsBuscar.descrEmpresa=argsBuscEstruct.descrEmpresa
    if(argsBuscEstruct.numDocum){
      argsBuscar.numDocum=parseInt(argsBuscEstruct.numDocum, 10)
    }else{
    }
    if(argsBuscEstruct.descrPlanta){
      argsBuscar.descrPlanta=argsBuscEstruct.descrPlanta
    }else{
      delete argsBuscar.descrPlanta
    }
    if(argsBuscEstruct.descrSeccion){
      argsBuscar.descrSeccion=argsBuscEstruct.descrSeccion
    }else{
      delete argsBuscar.descrSeccion
    }
    if(argsBuscEstruct.descrEquipo){
      argsBuscar.descrEquipo=argsBuscEstruct.descrEquipo
    }else{
      delete argsBuscar.descrEquipo
    }
    if(argsBuscEstruct.descrComponente){
      argsBuscar.descrComponente=argsBuscEstruct.descrComponente
    }else{
      delete argsBuscar.descrComponente
    }
    if(argsBuscEstruct.descrMecanismo){
      argsBuscar.descrMecanismo=argsBuscEstruct.descrMecanismo
    }else{
      delete argsBuscar.descrMecanismo
    }
    this.setState({argsBuscEstruct: argsBuscar});
  }

  handleChangeBuscGrado = (ev)=>{
    const argsBuscar = this.state.argsBuscar
    argsBuscar[ev.target.name] = ev.target.value
    this.setState({argsBuscar});
  }          

  handleBuscGrado = async (ev, args) => {
    let argsBuscar={}

    if(args.tipoGrado){
      argsBuscar.tipoGrado=args.tipoGrado
    }else{
      delete argsBuscar.tipoGrado
    }
    if(args.descrGrado){
      argsBuscar.descrGrado=args.descrGrado
    }else{
      delete argsBuscar.descrGrado
    }
    this.setState({argsBuscGrado: argsBuscar});
  }

  handleBuscStock = async (ev, args) => {
    let argsBuscar={}

    if(args.descrLubricante){
      argsBuscar.descrLubricante=args.descrLubricante
    }else{
      delete argsBuscar.descrLubricante
    }
    if(args.descrEmpresa){
      argsBuscar.descrEmpresa=args.descrEmpresa
    }else{
      delete argsBuscar.descrEmpresa
    }
    this.setState({argsBuscStock: argsBuscar});
  }

  estadosFalse = () => {
    this.setState({argsAdd: {}})
    this.setState({errorAdd: []})

    Object.values(this.state).forEach((estado, i) => {
      if(estado===true){
        this.setState({ [Object.getOwnPropertyNames(this.state)[i]]: false })
      }
    })
  }

  ordenarArrayAsc = (array, campo) => {
    array.sort(function (a, b) {
       return a[campo] > b[campo];
    });
  }

  showCar = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showCar: true})
  }

  showMetodo = (ev) => {
    ev.preventDefault()
    this.props.allMetodo.refetch()
    this.estadosFalse()
    this.setState({showMetodo: true})
  }  

  showTarea = (ev) => {
    ev.preventDefault()
    this.props.allTarea.refetch()
    this.estadosFalse()
    this.setState({showTarea: true})
  }  

  showFrecuencia = (ev) => {
    ev.preventDefault()
    this.props.allFrecuencia.refetch()
    this.estadosFalse()
    this.setState({showFrecuencia: true})
  }  

  showAplicacion = (ev) => {
    ev.preventDefault()
    this.props.allAplicacion.refetch()
    this.estadosFalse()
    this.setState({showAplicacion: true})
  }  

  showGrado = (ev) => {
    ev.preventDefault()
    this.props.allGrado.refetch()
    this.estadosFalse()
    this.setState({showGrado: true})
  }  

  showLubricante = (ev) => {
    ev.preventDefault()
    this.props.allLubricante.refetch()
    this.estadosFalse()
    this.setState({showLubricante: true})
  }
  
  showStockLub = (ev) => {
    ev.preventDefault()
    this.props.allLubricanteRtes.refetch()
    this.estadosFalse()
    this.setState({showStockLub: true})
  }

  showProcEjec = (ev) => {
    ev.preventDefault()
    this.props.allProcEjec.refetch()
    this.estadosFalse()
    this.setState({showProcEjec: true})
  }

  showInfoTarea = (ev) => {
    ev.preventDefault()
    this.props.allInfoTarea.refetch()
    this.estadosFalse()
    this.setState({showInfoTarea: true})
  }

  showDatCar = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showDatCar: true})
  }

  showSimRot = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showSimRot: true})
  }

  showGenRot = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showGenRot: true})
  }

  showAsImEq = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showAsImEq: true})
  }
  showAsImSecc = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showAsImSecc: true})
  }
  showImprCL = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showImprCL: true})
  }

  showAnexos = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showAnexos: true})
  }
  showPdfEq = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({showPdfEq: true})
  }
  addMetodo = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addMetodo: true})
  }

  addTarea = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addTarea: true})
  }

  addFrecuencia = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addFrecuencia: true})
  }

  addAplicacion = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addAplicacion: true})
  }  
  addGrado = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addGrado: true})
  }  

  addLubricante = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addLubricante: true})
  }  

  addStockLub = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addStockLub: true})
  }
  addProcEjec = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addProcEjec: true})
  }
  addInfoTarea = (ev) => {
    ev.preventDefault()
    this.estadosFalse()
    this.setState({addInfoTarea: true})
  }

  handleMetodo = async (ev, args, descrMetodoAnt)=>{
    if((!args.tipoLub||!args.descrMetodo) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.tipoLub||args.tipoLub==="Seleccionar..."){
        argsAdd['tipoLub'] = "Seleccionar...";
        errors.push({path: 'tipoLub', message: "Debe seleccionar el tipo de lubricante"});
      }
      if(!args.descrMetodo){
        argsAdd['descrMetodo'] = "";
        errors.push({path: 'descrMetodo', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addMetodo){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        response = await this.props.createMetodo({
          variables: args
        });
        const {errors, success} = response.data.createMetodo;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrMetodo = document.getElementById("descrMetodo");
          var tipoLub = document.getElementById("miLista1");
          tipoLub.options.selectedIndex = 0        
          descrMetodo.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allMetodo.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            tipoLub: args.tipoLub,
            descrMetodo: args.descrMetodo,
            descrMetodoAnt: descrMetodoAnt,
          }
          const response = await this.props.editMetodo({
            variables: argsUpd
          });
          const {errors, success} = response.data.editMetodo;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allMetodo.refetch()
            this.estadosFalse()
            this.setState({showMetodo: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteMetodo({
            variables: argsDel
          });
          this.props.allMetodo.refetch()
          this.estadosFalse()
          this.setState({showMetodo: true})
        }
      }
    }
  }

  handleTarea = async (ev, args, descrTareaAnt)=>{
    if((!args.tipoLub||!args.descrTarea) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.tipoLub||args.tipoLub==="Seleccionar..."){
        argsAdd['tipoLub'] = "Seleccionar...";
        errors.push({path: 'tipoLub', message: "Debe seleccionar el tipo de lubricante"});
      }
      if(!args.descrTarea){
        argsAdd['descrTarea'] = "";
        errors.push({path: 'descrTarea', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addTarea){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        response = await this.props.createTarea({
          variables: args
        });
        const {errors, success} = response.data.createTarea;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrTarea = document.getElementById("descrTarea");
          var tipoLub = document.getElementById("miLista1");
          tipoLub.options.selectedIndex = 0        
          descrTarea.value = ""
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allTarea.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            tipoLub: args.tipoLub,
            descrTarea: args.descrTarea,
            descrTareaAnt: descrTareaAnt,
          }
          const response = await this.props.editTarea({
            variables: argsUpd
          });
          const {errors, success} = response.data.editTarea;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allTarea.refetch()
            this.estadosFalse()
            this.setState({showTarea: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteTarea({
            variables: argsDel
          });
          this.props.allTarea.refetch()
          this.estadosFalse()
          this.setState({showTarea: true})
        }
      }
    }
  }

  handleFrecuencia = async (ev, args)=>{
    if((!args.tipoFrecuencia||!args.descrFrecuencia
      ||!args.abrevUnidad||args.abrevUnidad==="Seleccionar...") 
      && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrFrecuencia){
        argsAdd['descrFrecuencia'] = "";
        errors.push({path: 'descrFrecuencia', message: "Debe escribir la descripción"});
      }
      if(!args.tipoFrecuencia||args.tipoFrecuencia==="Seleccionar..."){
        argsAdd['tipoFrecuencia'] = "Seleccionar...";
        errors.push({path: 'tipoFrecuencia', message: "Debe seleccionar el tipo de frecuencia"});
      }
      if(!args.abrevUnidad||args.abrevUnidad==="Seleccionar..."){
        argsAdd['abrevUnidad'] = "Seleccionar...";
        errors.push({path: 'abrevUnidad', message: "Debe seleccionar la unidad de frecuencia"});
      }      
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addFrecuencia){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        response = await this.props.createFrecuencia({
          variables: args
        });
        const {errors, success} = response.data.createFrecuencia;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrFrecuencia = document.getElementById("descrFrecuencia");
          var tipoFrecuencia = document.getElementById("miLista1");
          var cantidad = document.getElementById("cantidad");
          var abrevUnidad = document.getElementById("miLista2");          
          tipoFrecuencia.options.selectedIndex = 0        
          descrFrecuencia.value = ""
          cantidad.value = 0
          abrevUnidad.options.selectedIndex = 0        
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allFrecuencia.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            tipoFrecuencia: args.tipoFrecuencia,
            descrFrecuencia: args.descrFrecuencia,
            cantidad: args.cantidad,
            abrevUnidad: args.abrevUnidad,
          }
          const response = await this.props.editFrecuencia({
            variables: argsUpd
          });
          const {errors, success} = response.data.editFrecuencia;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allFrecuencia.refetch()
            this.estadosFalse()
            this.setState({showFrecuencia: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteFrecuencia({
            variables: argsDel
          });
          this.props.allFrecuencia.refetch()
          this.estadosFalse()
          this.setState({showFrecuencia: true})
        }
      }
    }
  }

  handleAplicacion = async (ev, args, descrAplicacionAnt)=>{
    if((!args.tipoLub||!args.descrAplicacion) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.tipoLub||args.tipoLub==="Seleccionar..."){
        argsAdd['tipoLub'] = "Seleccionar...";
        errors.push({path: 'tipoLub', message: "Debe seleccionar el tipo de lubricante"});
      }
      if(!args.descrAplicacion){
        argsAdd['descrAplicacion'] = "";
        errors.push({path: 'descrAplicacion', message: "Debe escribir la descripción"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addAplicacion){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        if (args.tipoLub!=='Aceite'){
          args.sector=''
        }
        response = await this.props.createAplicacion({
          variables: args
        });
        const {errors, success} = response.data.createAplicacion;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrAplicacion = document.getElementById("descrAplicacion");
          var tipoLub = document.getElementById("miLista1");
          descrAplicacion.value = ""
          tipoLub.options.selectedIndex = 0
          if (args.tipoLub==='Aceite'){
            var sector = document.getElementById("miLista5");
            sector.options.selectedIndex = 0
          }
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allAplicacion.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            tipoLub: args.tipoLub,
            descrAplicacion: args.descrAplicacion,
            sector: args.sector,
            color: args.color, 
            descrAplicacionAnt: descrAplicacionAnt
          }
          if (argsUpd.tipoLub!=='Aceite'){
            argsUpd.sector=''
          }
          const response = await this.props.editAplicacion({
            variables: argsUpd
          });
          const {errors, success} = response.data.editAplicacion;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allAplicacion.refetch()
            this.estadosFalse()
            this.setState({showAplicacion: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteAplicacion({
            variables: argsDel
          });
          this.props.allAplicacion.refetch()
          this.estadosFalse()
          this.setState({showAplicacion: true})
        }
      }
    }
  }

  handleGrado = async (ev, args, tipoGradoAnt, descrGradoAnt, apiSAEAnt)=>{
    if((!args.tipoLub||args.tipoLub==="Seleccionar..."||!args.descrGrado||
    !args.tipoGrado||args.tipoGrado==="Seleccionar..."||
    !args.color||!args.colorTexto||args.colorTexto==="Seleccionar..."||
    (args.tipoLub==='Aceite' && (!args.sector||args.sector==="Seleccionar..."||
    (args.sector!=='INDUSTRIAL' && (!args.aplicacionSAE||args.aplicacionSAE==="Seleccionar..."||
    !args.categoriaSAE||args.categoriaSAE==="Seleccionar..."))))) 
        && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.tipoLub||args.tipoLub==="Seleccionar..."){
        argsAdd['tipoLub'] = "Seleccionar...";
        errors.push({path: 'tipoLub', message: "Debe seleccionar el tipo de lubricante"});
      }
      if(!args.tipoGrado||args.tipoGrado==="Seleccionar..."){
        argsAdd['tipoGrado'] = "Seleccionar...";
        errors.push({path: 'tipoGrado', message: "Debe seleccionar el tipo de grado"});
      }
      if(!args.descrGrado){
        argsAdd['descrGrado'] = "";
        errors.push({path: 'descrGrado', message: "Debe escribir la descripción"});
      }
      if(!args.color){
        argsAdd['color'] = "";
        errors.push({path: 'color', message: "Debe seleccionar el color"});
      }
      if(!args.colorTexto||args.colorTexto==="Seleccionar..."){
        argsAdd['colorTexto'] = "Seleccionar...";
        errors.push({path: 'colorTexto', message: "Debe seleccionar el color del texto"});
      }      
      if (args.tipoLub==='Aceite'){
        if(!args.sector||args.sector==="Seleccionar..."){
          argsAdd['sector'] = "Seleccionar...";
          errors.push({path: 'sector', message: "Debe seleccionar el sector"});
        }
        if (args.sector!=='INDUSTRIAL'){
          if(!args.aplicacionSAE||args.aplicacionSAE==="Seleccionar..."){
            argsAdd['aplicacionSAE'] = "Seleccionar...";
            errors.push({path: 'aplicacionSAE', message: "Debe seleccionar la aplicación SAE"});
          }
          if(!args.categoriaSAE||args.categoriaSAE==="Seleccionar..."){
            argsAdd['categoriaSAE'] = "Seleccionar...";
            errors.push({path: 'categoriaSAE', message: "Debe seleccionar la categoría SAE"});
          }  
        }
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      let response = await this.props.fecha({
        variables: {}
      });
      const {fechaHoraHoy} = response.data.fecha
      if(this.state.addGrado){
        args.fechaCreate = fechaHoraHoy
        if (args.tipoLub!=='Aceite'){
          args.sector=''
          args.aplicacionSAE=''
          args.categoriaSAE=''
          args.apiSAE=''
        }else{
          if (args.sector==='INDUSTRIAL'){
            args.aplicacionSAE=''
            args.categoriaSAE=''
            args.apiSAE=''
          }
        }
        response = await this.props.createGrado({
          variables: args
        });
        const {errors, success} = response.data.createGrado;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var tipoLub = document.getElementById("miLista8");
          var tipoGrado = document.getElementById("miLista1");
          var descrGrado = document.getElementById("descrGrado");
          descrGrado.value = ""
          tipoLub.options.selectedIndex = 0
          tipoGrado.options.selectedIndex = 0
          if (args.tipoLub==='Aceite'){
            var sector = document.getElementById("miLista5");
            sector.options.selectedIndex = 0
            if (args.sector==='AUTOMOTRIZ'){
              var aplicacionSAE = document.getElementById("miLista2");   
              var categoriaSAE = document.getElementById("miLista3"); 
              aplicacionSAE.options.selectedIndex = 0
              categoriaSAE.options.selectedIndex = 0
              if (args.aplicacionSAE==='MOTORES COMBUSTION INTERNA'){
                var apiSAE = document.getElementById("miLista4");    
                apiSAE.options.selectedIndex = 0
              }
              if (args.aplicacionSAE==='ENGRANAJES AUTOMOTRICES'){
                var apiSAE = document.getElementById("miLista7");    
                apiSAE.options.selectedIndex = 0
              }
            }
          }
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allGrado.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrGrado: args.descrGrado,
            tipoLub: args.tipoLub,
            tipoGrado: args.tipoGrado,
            tipoGradoAnt: tipoGradoAnt,
            descrGradoAnt: descrGradoAnt,
            apiSAEAnt: apiSAEAnt,
            sector: args.sector,
            aplicacionSAE: args.aplicacionSAE, 
            categoriaSAE: args.categoriaSAE, 
            apiSAE: args.apiSAE, 
            color: args.color, 
            colorTexto: args.colorTexto 
          }
          if (argsUpd.tipoLub!=='Aceite'){
            argsUpd.sector=''
            argsUpd.aplicacionSAE=''
            argsUpd.categoriaSAE=''
            argsUpd.apiSAE=''
          }else{
            if (args.sector==='INDUSTRIAL'){
              argsUpd.aplicacionSAE=''
              argsUpd.categoriaSAE=''
              argsUpd.apiSAE=''
            }
          }          
          const response = await this.props.editGrado({
            variables: argsUpd
          });
          const {errors, success} = response.data.editGrado;
          if (!success){
            console.log(errors)
            this.setState({errorAdd: errors})
          }else{
            this.props.allGrado.refetch()
            this.estadosFalse()
            this.setState({showGrado: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteGrado({
            variables: argsDel
          });
          this.props.allGrado.refetch()
          this.estadosFalse()
          this.setState({showGrado: true})
        }
      }
    }
  }

  nextVal = async (name) => {
    const argsUpd = {
      coleccion: name,
    }
    const response = await this.props.editSeqfindOneAndUpdate({
      variables: argsUpd
    });
    return response.data.editSeqfindOneAndUpdate.seq
  }

  handleLubricante = async (ev, args, descrLubricanteAnt)=>{
    console.log(args)
    if((!args.descrLubricante||!args.descrFabricante
      ||!args.tipoLub||args.tipoLub==="Seleccionar..."
      ||!args.claseLub||args.claseLub==="Seleccionar..."
      ||!args.categoriaLub||args.categoriaLub==="Seleccionar..."
      ||!args.tipoGrado||args.tipoGrado==="Seleccionar..."
      ||!args.descrGrado||args.descrGrado==="Seleccionar..."
      ||(args.tipoLub==='Grasa' && args.isoGrasa==="Seleccionar..."))
      && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrLubricante){
        argsAdd['descrLubricante'] = "";
        errors.push({path: 'descrLubricante', message: "Debe escribir la descripción"});
      }
      if(!args.descrFabricante){
        argsAdd['descrFabricante'] = "";
        errors.push({path: 'descrFabricante', message: "Debe escribir la marca o fabricante"});
      }
      if(!args.tipoLub||args.tipoLub==="Seleccionar..."){
        argsAdd['tipoLub'] = "Seleccionar...";
        errors.push({path: 'tipoLub', message: "Debe seleccionar el tipo de lubricante"});
      }
      if(!args.claseLub||args.claseLub==="Seleccionar..."){
        argsAdd['claseLub'] = "Seleccionar...";
        errors.push({path: 'claseLub', message: "Debe seleccionar la clase de lubricante"});
      }
      if(!args.categoriaLub||args.categoriaLub==="Seleccionar..."){
        argsAdd['categoriaLub'] = "Seleccionar...";
        errors.push({path: 'categoriaLub', message: "Debe seleccionar la categoría de lubricante"});
      }      
      if(!args.tipoGrado||args.tipoGrado==="Seleccionar..."){
        argsAdd['tipoGrado'] = "Seleccionar...";
        errors.push({path: 'tipoGrado', message: "Debe seleccionar el grado del lubricante"});
      }      
      if(!args.descrGrado||args.descrGrado==="Seleccionar..."){
        argsAdd['descrGrado'] = "Seleccionar...";
        errors.push({path: 'descrGrado', message: "Debe seleccionar el grado del lubricante"});
      }    
      if (args.tipoLub==='Grasa'){
        if(!args.isoGrasa||args.isoGrasa==="Seleccionar..."){
          argsAdd['isoGrasa'] = "Seleccionar...";
          errors.push({path: 'isoGrasa', message: "Debe seleccionar el grado iso de la grasa"});
        }
      }  
      if (args.tipoLub==='Aceite'){
        if(!args.metalicos||args.metalicos==="Seleccionar..."){
          argsAdd['metalicos'] = "Seleccionar...";
          errors.push({path: 'metalicos', message: "Debe seleccionar Aditivos metálicos AW/EP"});
        }
        if(!args.nsf||args.nsf==="Seleccionar..."){
          argsAdd['nsf'] = "Seleccionar...";
          errors.push({path: 'nsf', message: "Debe seleccionar NSF ISO 21469:2006"});
        }
        if(!args.fda||args.fda==="Seleccionar..."){
          argsAdd['fda'] = "Seleccionar...";
          errors.push({path: 'fda', message: "Debe seleccionar FDA"});
        }
        if(!args.biodegradables||args.biodegradables==="Seleccionar..."){
          argsAdd['biodegradables'] = "Seleccionar...";
          errors.push({path: 'biodegradables', message: "Debe seleccionar Biodegradables OECD 301 B"});
        }
        if(!args.noToxico||args.noToxico==="Seleccionar..."){
          argsAdd['noToxico'] = "Seleccionar...";
          errors.push({path: 'noToxico', message: "Debe seleccionar No toxico EPA560/6-82-002"});
        }
        if(!args.ignifugo||args.ignifugo==="Seleccionar..."){
          argsAdd['ignifugo'] = "Seleccionar...";
          errors.push({path: 'ignifugo', message: "Debe seleccionar Ignifugo"});
        }
        if(!args.cumple||args.cumple==="Seleccionar..."){
          argsAdd['cumple'] = "Seleccionar...";
          errors.push({path: 'cumple', message: "Debe seleccionar Cumple con la norma FM 6930"});
        }
        if(!args.salud||args.salud==="Seleccionar..."){
          argsAdd['salud'] = "Seleccionar...";
          errors.push({path: 'salud', message: "Debe seleccionar Salud"});
        }
        if(!args.inflamabilidad||args.inflamabilidad==="Seleccionar..."){
          argsAdd['inflamabilidad'] = "Seleccionar...";
          errors.push({path: 'inflamabilidad', message: "Debe seleccionar Inflamabilidad"});
        }
        if(!args.reactividad||args.reactividad==="Seleccionar..."){
          argsAdd['reactividad'] = "Seleccionar...";
          errors.push({path: 'reactividad', message: "Debe seleccionar Reactividad"});
        }
        if(!args.blanco||args.blanco==="Seleccionar..."){
          argsAdd['blanco'] = "Seleccionar...";
          errors.push({path: 'blanco', message: "Debe seleccionar el campo Blanco"});
        }
      }  
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addLubricante){
        let response = await this.props.fecha({
          variables: {}
        });
        const {fechaHoraHoy} = response.data.fecha
        args.fechaCreate = fechaHoraHoy
        if (args.tipoLub!=='Aceite'){
          args.color=0
          args.visco40=0
          args.visco100=0
          args.indice=0
          args.agua=0
          args.codigoPar=''
          args.micras4=0
          args.micras6=0
          args.micras14=0
          args.micras21=0
          args.micras25=0
          args.micras38=0
          args.micras70=0
          args.hollin=0
          args.nitracion=0
          args.sulfatacion=0
          args.dilucion=0
          args.glicol=0
          args.oxidacion=0
          args.tan=0
          args.tbn=0
          args.hierro=0
          args.cobre=0
          args.aluminio=0
          args.cromo=0
          args.plomo=0
          args.estano=0
          args.niquel=0
          args.vanadio=0
          args.titanio=0
          args.silicio=0
          args.sodio=0
          args.potasio=0
          args.boro=0
          args.magnesio=0
          args.calcio=0
          args.fosforo=0
          args.zinc=0
          args.molibdeno=0
          args.bario=0
          args.manganeso=0
          args.fluidez=0
          args.inflamacion=0
          args.cenizas=0
          args.tost=0
          args.rpvot=0
          args.metalicos=''
          args.phosporus=0
          args.grasa=0
          args.separabilidad=0
          args.abrasion=0
          args.bolas=0
          args.huella=0
          args.timken=0
          args.espuma=''
          args.secuencia1=0
          args.secuencia2=0
          args.secuencia3=0
          args.aeroemulsion=0
          args.demulsibilidad=0
          args.emulsion=0
          args.corrosion=''
          args.ultracentrifuga=''
          args.densidad=''
          args.fuego=''
          args.herrumbre=''
          args.destilada=''
          args.deMar=''
          args.temperatura=0
          args.penetracion=0
          args.goteo=0
          args.lavado=0
          args.nsf=''
          args.fda=''
          args.biodegradables=''
          args.noToxico=''
          args.ignifugo=''
          args.cumple=''
          args.salud=''
          args.inflamabilidad=''
          args.reactividad=''
          args.blanco=''
          args.pq=0
          args.fischer=0
          args.tanpte=0
          args.tbnpte=0
        }
        response =  await this.props.createLubricante({
          variables: args
        });
        const {errors, success} = response.data.createLubricante;
        if (!success){
          this.setState({errorAdd: errors})
        }else{
          var descrLubricante = document.getElementById("descrLubricante");
          var descrFabricante = document.getElementById("descrFabricante");
          var tipoLub = document.getElementById("miLista5");
          var claseLub = document.getElementById("miLista2");
          var categoriaLub = document.getElementById("miLista3");   
          var tipoGrado = document.getElementById("miLista1"); 
          var descrGrado = document.getElementById("miLista4");  
          var isoGrasa = document.getElementById("miLista44");  
          descrLubricante.value = ""
          descrFabricante.value = ""
          tipoLub.options.selectedIndex = 0
          claseLub.options.selectedIndex = 0
          categoriaLub.options.selectedIndex = 0
          tipoGrado.options.selectedIndex = 0
          descrGrado.options.selectedIndex = 0
          if (args.tipoLub==='Aceite'){
            var color = document.getElementById("color");
            color.value=0
            var visco40 = document.getElementById("visco40");      
            visco40.value = 0
            var visco100 = document.getElementById("visco100");      
            visco100.value = 0
            var indice = document.getElementById("indice");      
            indice.value = 0
            var agua = document.getElementById("agua");      
            agua.value = 0
            var codigoPar = document.getElementById("codigoPar");      
            codigoPar.value = ""
            var micras4 = document.getElementById("micras4");      
            micras4.value = 0
            var micras6 = document.getElementById("micras6");      
            micras6.value = 0
            var micras14 = document.getElementById("micras14");      
            micras14.value = 0
            var micras21 = document.getElementById("micras21");      
            micras21.value = 0
            var micras25 = document.getElementById("micras25");      
            micras25.value = 0
            var micras38 = document.getElementById("micras38");      
            micras38.value = 0
            var micras70 = document.getElementById("micras70");      
            micras70.value = 0
            var hollin = document.getElementById("hollin");      
            hollin.value = 0
            var nitracion = document.getElementById("nitracion");      
            nitracion.value = 0
            var sulfatacion = document.getElementById("sulfatacion");      
            sulfatacion.value = 0
            var dilucion = document.getElementById("dilucion");      
            dilucion.value = 0
            var glicol = document.getElementById("glicol");      
            glicol.value = 0
            var oxidacion = document.getElementById("oxidacion");      
            oxidacion.value = 0
            var tan = document.getElementById("tan");      
            tan.value = 0
            var tbn = document.getElementById("tbn");      
            tbn.value = 0
            var hierro = document.getElementById("hierro");      
            hierro.value = 0
            var cobre = document.getElementById("cobre");      
            cobre.value = 0
            var aluminio = document.getElementById("aluminio");      
            aluminio.value = 0
            var cromo = document.getElementById("cromo");      
            cromo.value = 0
            var plomo = document.getElementById("plomo");      
            plomo.value = 0
            var estano = document.getElementById("estano");      
            estano.value = 0
            var niquel = document.getElementById("niquel");      
            niquel.value = 0
            var vanadio = document.getElementById("vanadio");      
            vanadio.value = 0
            var titanio = document.getElementById("titanio");      
            titanio.value = 0
            var silicio = document.getElementById("silicio");      
            silicio.value = 0
            var sodio = document.getElementById("sodio");      
            sodio.value = 0
            var potasio = document.getElementById("potasio");      
            potasio.value = 0
            var boro = document.getElementById("boro");      
            boro.value = 0
            var magnesio = document.getElementById("magnesio");      
            magnesio.value = 0
            var calcio = document.getElementById("calcio");      
            calcio.value = 0
            var fosforo = document.getElementById("fosforo");      
            fosforo.value = 0
            var zinc = document.getElementById("zinc");      
            zinc.value = 0
            var molibdeno = document.getElementById("molibdeno");      
            molibdeno.value = 0
            var bario = document.getElementById("bario");      
            bario.value = 0
            var manganeso = document.getElementById("manganeso");      
            manganeso.value = 0
            var fluidez = document.getElementById("fluidez");      
            fluidez.value = 0
            var inflamacion = document.getElementById("inflamacion");      
            inflamacion.value = 0
            var cenizas = document.getElementById("cenizas");      
            cenizas.value = 0
            var tost = document.getElementById("tost");      
            tost.value = 0
            var rpvot = document.getElementById("rpvot");      
            rpvot.value = 0
            var metalicos = document.getElementById("miLista6");      
            metalicos.options.selectedIndex = 0
            var phosporus = document.getElementById("phosporus");      
            phosporus.value = 0
            var grasa = document.getElementById("grasa");      
            grasa.value = 0
            var separabilidad = document.getElementById("separabilidad");      
            separabilidad.value = 0
            var abrasion = document.getElementById("abrasion");      
            abrasion.value = 0
            var bolas = document.getElementById("bolas");      
            bolas.value = 0
            var huella = document.getElementById("huella");      
            huella.value = 0
            var timken = document.getElementById("timken");      
            timken.value = 0
            var espuma = document.getElementById("espuma");      
            espuma.value = ""
            var secuencia1 = document.getElementById("secuencia1");      
            secuencia1.value = 0
            var secuencia2 = document.getElementById("secuencia2");      
            secuencia2.value = 0
            var secuencia3 = document.getElementById("secuencia3");      
            secuencia3.value = 0
            var aeroemulsion = document.getElementById("aeroemulsion");      
            aeroemulsion.value = 0
            var demulsibilidad = document.getElementById("demulsibilidad");      
            demulsibilidad.value = 0
            var emulsion = document.getElementById("emulsion");      
            emulsion.value = 0
            var corrosion = document.getElementById("corrosion");      
            corrosion.value = ""
            var ultracentrifuga = document.getElementById("ultracentrifuga");      
            ultracentrifuga.value = ""
            var densidad = document.getElementById("densidad");      
            densidad.value = ""
            var fuego = document.getElementById("fuego");      
            fuego.value = ""
            var pq = document.getElementById("pq");      
            pq.value = 0
            var fischer = document.getElementById("fischer");      
            fischer.value = 0
            var tanpte = document.getElementById("tanpte");      
            tanpte.value = 0
            var tbnpte = document.getElementById("tbnpte");      
            tbnpte.value = 0
            var herrumbre = document.getElementById("herrumbre");      
            herrumbre.value = ""
            var destilada = document.getElementById("destilada");      
            destilada.value = ""
            var deMar = document.getElementById("deMar");      
            deMar.value = ""
            var temperatura = document.getElementById("temperatura");      
            temperatura.value = 0
            var penetracion = document.getElementById("penetracion");      
            penetracion.value = 0
            var goteo = document.getElementById("goteo");      
            goteo.value = 0
            var lavado = document.getElementById("lavado");      
            lavado.value = 0
            var nsf = document.getElementById("miLista7");      
            nsf.options.selectedIndex = 0
            var fda = document.getElementById("miLista8");      
            fda.options.selectedIndex = 0
            var biodegradables = document.getElementById("miLista9");      
            biodegradables.options.selectedIndex = 0
            var noToxico = document.getElementById("miLista10");      
            noToxico.options.selectedIndex = 0
            var ignifugo = document.getElementById("miLista11");      
            ignifugo.options.selectedIndex = 0
            var cumple = document.getElementById("miLista12");      
            cumple.options.selectedIndex = 0
            var salud = document.getElementById("miLista13");      
            salud.options.selectedIndex = 0
            var inflamabilidad = document.getElementById("miLista14");      
            inflamabilidad.options.selectedIndex = 0
            var reactividad = document.getElementById("miLista15");      
            reactividad.options.selectedIndex = 0
            var blanco = document.getElementById("miLista16");      
            blanco.options.selectedIndex = 0
          }
          this.setState({errorAdd: []})
          this.setState({argsAdd: {}})
          this.props.allLubricante.refetch()
        }
      }else{
        if(this.state.permiteUpdate){
          var miLista4 = document.getElementById("miLista4");
          var miLista44 = document.getElementById("miLista44");
          let isoGr=''
          let isoColor=''
          let isoTexto=''
          if(args.tipoLub==='Grasa'){
            isoGr= args.isoGrasa    
            isoColor= miLista44.options[miLista44.selectedIndex].attributes[0].value                 
            isoTexto= miLista44.options[miLista44.selectedIndex].attributes[1].value
          }
          const argsUpd = {
            _id: args._id,
            claseLub: args.claseLub,
            descrLubricante: args.descrLubricante,
            descrLubricanteAnt: descrLubricanteAnt,
            descrFabricante: args.descrFabricante,
            tipoLub: args.tipoLub,
            categoriaLub: args.categoriaLub, 
            tipoGrado: args.tipoGrado, 
            descrGrado: args.descrGrado, 
            apiSAE: miLista4.options[miLista4.selectedIndex].attributes[1].value,                 
            colorGrado: miLista4.options[miLista4.selectedIndex].attributes[2].value,   
            isoGrasa: isoGr,    
            isoGrasaColor: isoColor,                 
            isoGrasaTexto: isoTexto,   
            color: args.color,
            visco40: args.visco40, 
            visco100: args.visco100, 
            indice: args.indice,
            agua: args.agua,
            codigoPar: args.codigoPar,
            micras4: args.micras4,
            micras6: args.micras6,
            micras14: args.micras14,
            micras21: args.micras21,
            micras25: args.micras25,
            micras38: args.micras38,
            micras70: args.micras70,
            hollin: args.hollin,
            nitracion: args.nitracion,
            sulfatacion: args.sulfatacion,
            dilucion: args.dilucion,
            glicol: args.glicol,
            oxidacion: args.oxidacion,
            tan: args.tan,
            tbn: args.tbn,
            hierro: args.hierro,
            cobre: args.cobre,
            aluminio: args.aluminio,
            cromo: args.cromo,
            plomo: args.plomo,
            estano: args.estano,
            niquel: args.niquel,
            vanadio: args.vanadio,
            titanio: args.titanio,
            silicio: args.silicio,
            sodio: args.sodio,
            potasio: args.potasio,
            boro: args.boro,
            magnesio: args.magnesio,
            calcio: args.calcio,
            fosforo: args.fosforo,
            zinc: args.zinc,
            molibdeno: args.molibdeno,
            bario: args.bario,
            manganeso: args.manganeso,
            fluidez: args.fluidez,
            inflamacion: args.inflamacion,
            cenizas: args.cenizas,
            tost: args.tost,
            rpvot: args.rpvot,
            metalicos: args.metalicos,
            phosporus: args.phosporus,
            grasa: args.grasa,
            separabilidad: args.separabilidad,
            abrasion: args.abrasion,
            bolas: args.bolas,
            huella: args.huella,
            timken: args.timken,
            espuma: args.espuma,
            secuencia1: args.secuencia1,
            secuencia2: args.secuencia2,
            secuencia3: args.secuencia3,
            aeroemulsion: args.aeroemulsion,
            demulsibilidad: args.demulsibilidad,
            emulsion: args.emulsion,
            corrosion: args.corrosion,
            ultracentrifuga: args.ultracentrifuga,
            densidad: args.densidad,
            fuego: args.fuego,
            herrumbre: args.herrumbre,
            destilada: args.destilada,
            deMar: args.deMar,
            temperatura: args.temperatura,
            penetracion: args.penetracion,
            goteo: args.goteo,
            lavado: args.lavado,
            nsf: args.nsf,
            fda: args.fda,
            biodegradables: args.biodegradables,
            noToxico: args.noToxico,
            ignifugo: args.ignifugo,
            cumple: args.cumple,
            salud: args.salud,
            inflamabilidad: args.inflamabilidad,
            reactividad: args.reactividad,
            blanco: args.blanco,
            pq: args.pq,
            fischer: args.fischer,
            tanpte: args.tanpte,
            tbnpte: args.tbnpte,
            tipoAct: 'EditarLubricante'
          }
          const response = await this.props.editLubricante({
            variables: argsUpd
          });
          const {errors, success} = response.data.editLubricante;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allLubricante.refetch()
            this.estadosFalse()
            this.setState({showLubricante: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id
          }
          await this.props.deleteLubricante({
            variables: argsDel
          });
          this.props.allLubricante.refetch()
          this.estadosFalse()
          this.setState({showLubricante: true})
        }
      }
    }
  }

  handleProcEjec = async (ev, args, codProcedimientoAnt)=>{
    if((!args.codProcedimiento||!args.descrProcedimiento ||(!args.nombreArchivo && !args.nombreArchivoAnt && this.state.permiteUpdate)
      ||(!args.nombreArchivo && this.state.addProcEjec)) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrProcedimiento){
        argsAdd['descrProcedimiento'] = "";
        errors.push({path: 'descrProcedimiento', message: "Debe escribir el titulo del procedimiento"});
      }
      if(!args.codProcedimiento){
        argsAdd['codProcedimiento'] = "";
        errors.push({path: 'codProcedimiento', message: "Debe escribir el código de procedimiento"});
      }
      if((!args.nombreArchivo && !args.nombreArchivoAnt && this.state.permiteUpdate) || (!args.nombreArchivo && this.state.addProcEjec)){
        argsAdd['nombreArchivo'] = "";
        errors.push({path: 'nombreArchivo', message: "Debe seleccionar el archivo"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addProcEjec){
        let indexProcEjec = await this.props.allProcEjec.allProcEjec.findIndex( elementoPE => elementoPE.codProcedimiento === args.codProcedimiento );
        let indexProcEjec1 = await this.props.allProcEjec.allProcEjec.findIndex( elementoPE => elementoPE.descrProcedimiento === args.descrProcedimiento || elementoPE.nombreArchivo === args.nombreArchivo );
        if(indexProcEjec!==-1 || indexProcEjec1!==-1){
          const argsAdd = this.state.argsAdd
          const errors = [];
          if(indexProcEjec!==-1){
            argsAdd['codProcedimiento'] = "";
            errors.push({path: 'codProcedimiento', message: "El código de procedimiento ya existe"});  
          }
          if(indexProcEjec1!==-1){
            argsAdd['nombreArchivo'] = "";
            argsAdd['descrProcedimiento'] = "";
            errors.push({path: 'nombreArchivo', message: "El titulo o el archivo de procedimiento YA existe"});  
          }
          this.setState({argsAdd});
          this.setState({errorAdd: errors})
        }else{
          let response = await this.props.singleUpload({variables: {file: args.file}}); 
          response = await this.props.fecha({
            variables: {}
          });
          const {fechaHoraHoy} = response.data.fecha
          args.fechaCreate = fechaHoraHoy
          args.descrProcedimiento = args.descrProcedimiento.replace(/\./g,'') //quitar puntos
  
          response =  await this.props.createProcEjec({
            variables: args
          });
          const {errors, success} = response.data.createProcEjec;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            document.getElementById("file").value = ""
  
            var codProcedimiento = document.getElementById("codProcedimiento");
            codProcedimiento.value = ""
            var descrProcedimiento = document.getElementById("descrProcedimiento");
            descrProcedimiento.value = ""
            this.setState({errorAdd: []})
            this.props.allProcEjec.refetch()
          }
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrProcedimiento: args.descrProcedimiento,
            codProcedimiento: args.codProcedimiento,
            codProcedimientoAnt: codProcedimientoAnt,
            nombreArchivo: args.nombreArchivo?args.nombreArchivo:'',
            nombreArchivoAnt: args.nombreArchivoAnt?args.nombreArchivoAnt:'',
            modArch1: 'N'
          }
          if(args.nombreArchivo!==null && args.nombreArchivo!=='' && args.nombreArchivo!==args.nombreArchivoAnt){
            argsUpd.modArch1 = "S"
            let response = await this.props.singleUpload({variables: {file: args.file}});
          }
          const response = await this.props.editProcEjec({
            variables: argsUpd
          });
          const {errors, success} = response.data.editProcEjec;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allProcEjec.refetch()
            this.estadosFalse()
            this.setState({showProcEjec: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id,
            descrProcedimiento: args.descrProcedimiento.replace(/\./g,''), //quitar puntos
            nombreArchivo: args.nombreArchivo?args.nombreArchivo:'',
          }
          console.log(argsDel)
          await this.props.deleteProcEjec({
            variables: argsDel
          });
          this.props.allProcEjec.refetch()
          this.estadosFalse()
          this.setState({showProcEjec: true})
        }
      }
    }
  }

  handleInfoTarea = async (ev, args, codInfoTareaAnt)=>{
    if((!args.codInfoTarea||!args.descrInfoTarea ||(!args.nombreArchivoInfo && !args.nombreArchivoInfoAnt && this.state.permiteUpdate)
      ||(!args.nombreArchivoInfo && this.state.addInfoTarea)) && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!args.descrInfoTarea){
        argsAdd['descrInfoTarea'] = "";
        errors.push({path: 'descrInfoTarea', message: "Debe escribir la descripción de la advertencia de tarea"});
      }
      if(!args.codInfoTarea){
        argsAdd['codInfoTarea'] = "";
        errors.push({path: 'codInfoTarea', message: "Debe escribir el código de advertencia"});
      }
      if((!args.nombreArchivoInfo && !args.nombreArchivoInfoAnt && this.state.permiteUpdate) || (!args.nombreArchivoInfo && this.state.addInfoTarea)){
        argsAdd['nombreArchivoInfo'] = "";
        errors.push({path: 'nombreArchivoInfo', message: "Debe seleccionar el archivo"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.addInfoTarea){
        let indexInfoTarea = await this.props.allInfoTarea.allInfoTarea.findIndex( elementoPE => elementoPE.codInfoTarea === args.codInfoTarea );
        let indexInfoTarea1 = await this.props.allInfoTarea.allInfoTarea.findIndex( elementoPE => elementoPE.descrInfoTarea === args.descrInfoTarea || elementoPE.nombreArchivoInfo === args.nombreArchivoInfo );
        if(indexInfoTarea!==-1 || indexInfoTarea1!==-1){
          const argsAdd = this.state.argsAdd
          const errors = [];
          if(indexInfoTarea!==-1){
            argsAdd['codInfoTarea'] = "";
            errors.push({path: 'codInfoTarea', message: "El código de advertencia ya existe"});  
          }
          if(indexInfoTarea1!==-1){
            argsAdd['nombreArchivoInfo'] = "";
            argsAdd['descrInfoTarea'] = "";
            errors.push({path: 'nombreArchivoInfo', message: "La descripción o el archivo de advertencia YA existe"});  
          }
          this.setState({argsAdd});
          this.setState({errorAdd: errors})
        }else{
          let response = await this.props.singleUpload({variables: {file: args.file}}); 
          response = await this.props.fecha({
            variables: {}
          });
          const {fechaHoraHoy} = response.data.fecha
          args.fechaCreate = fechaHoraHoy
          args.descrInfoTarea = args.descrInfoTarea.replace(/\./g,'') //quitar puntos
  
          response =  await this.props.createInfoTarea({
            variables: args
          });
          const {errors, success} = response.data.createInfoTarea;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            document.getElementById("file").value = ""
  
            var codInfoTarea = document.getElementById("codInfoTarea");
            codInfoTarea.value = ""
            var descrInfoTarea = document.getElementById("descrInfoTarea");
            descrInfoTarea.value = ""
            this.setState({errorAdd: []})
            this.props.allInfoTarea.refetch()
          }
        }
      }else{
        if(this.state.permiteUpdate){
          const argsUpd = {
            _id: args._id,
            descrInfoTarea: args.descrInfoTarea,
            codInfoTarea: args.codInfoTarea,
            codInfoTareaAnt: codInfoTareaAnt,
            nombreArchivoInfo: args.nombreArchivoInfo?args.nombreArchivoInfo:'',
            nombreArchivoInfoAnt: args.nombreArchivoInfoAnt?args.nombreArchivoInfoAnt:'',
            modArch1: 'N'
          }
          // if(args.nombreArchivoInfo!==null && args.nombreArchivoInfo!=='' && args.nombreArchivoInfo!==args.nombreArchivoInfoAnt){
          if ( argsUpd.modArch1 = "N"){  
            argsUpd.modArch1 = "S"
            let response = await this.props.singleUpload({variables: {file: args.file}});
          }
          // }
          const response = await this.props.editInfoTarea({
            variables: argsUpd
          });
          const {errors, success} = response.data.editInfoTarea;
          if (!success){
            this.setState({errorAdd: errors})
          }else{
            this.props.allInfoTarea.refetch()
            this.estadosFalse()
            this.setState({showInfoTarea: true})
          }
        }
        if(this.state.permiteDelete){
          const argsDel = {
            _id: args._id,
            descrInfoTarea: args.descrInfoTarea.replace(/\./g,''), //quitar puntos
            nombreArchivoInfo: args.nombreArchivoInfo?args.nombreArchivoInfo:'',
          }
          await this.props.deleteInfoTarea({
            variables: argsDel
          });
          this.props.allInfoTarea.refetch()
          this.estadosFalse()
          this.setState({showInfoTarea: true})
        }
      }
    }
  }

  handleChange = (ev)=>{
    const argsAdd = this.state.argsAdd
    if(ev.target.type==='checkbox'){
      argsAdd[ev.target.name] = ev.target.checked
    }else{
      argsAdd[ev.target.name] = ev.target.value
    }
    this.setState({argsAdd});
  }

  handleSelclaseLub = () => {
    var miLista2 = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['claseLub'] = miLista2.options[miLista2.selectedIndex].text
    this.setState({argsAdd});
  } 

  handleSeltipoLub = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['tipoLub'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }  

  handleSeltipoLubri = () => {
    var miLista = document.getElementById("miLista5");
    const argsAdd = this.state.argsAdd
    argsAdd['tipoLub'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  } 
  handleSelcatLub = () => {
    var miLista3 = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['categoriaLub'] = miLista3.options[miLista3.selectedIndex].text
    this.setState({argsAdd});
  }  

  handleSeltipoFrecuencia = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['tipoFrecuencia'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }  

  handleSelabrevUnidad = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['abrevUnidad'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }  

  handleSelsector = () => {
    var miLista5 = document.getElementById("miLista5");
    const argsAdd = this.state.argsAdd
    argsAdd['sector'] = miLista5.options[miLista5.selectedIndex].text
    this.setState({argsAdd});
  }  

  handleSelaplisae = () => {
    var miLista6 = document.getElementById("miLista6");
    const argsAdd = this.state.argsAdd
    argsAdd['aplicacionSAE'] = miLista6.options[miLista6.selectedIndex].text
    this.setState({argsAdd});
  }    

  handleSelcatsae = () => {
    var miLista3 = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    argsAdd['categoriaSAE'] = miLista3.options[miLista3.selectedIndex].text
    this.setState({argsAdd});
  }  

  handleSelapisae = () => {
    var miLista4 = document.getElementById("miLista4");
    const argsAdd = this.state.argsAdd
    argsAdd['apiSAE'] = miLista4.options[miLista4.selectedIndex].text
    this.setState({argsAdd});
  }  

  handleSelapisae2 = () => {
    var miLista7 = document.getElementById("miLista7");
    const argsAdd = this.state.argsAdd
    argsAdd['apiSAE'] = miLista7.options[miLista7.selectedIndex].text
    this.setState({argsAdd});
  } 

  handleColor = (color) => {
    const argsAdd = this.state.argsAdd
    argsAdd['color'] = color.hex
    this.setState({argsAdd});
  }    

  handleSeltipoGrado = () => {
    var miLista1 = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['tipoGrado'] = miLista1.options[miLista1.selectedIndex].text
    this.setState({argsAdd});
  }  

  handleSeldescrGrado = () => {
    var miLista4 = document.getElementById("miLista4");
    const argsAdd = this.state.argsAdd
    argsAdd['descrGrado'] = miLista4.options[miLista4.selectedIndex].attributes[0].value
    argsAdd['apiSAE'] = miLista4.options[miLista4.selectedIndex].attributes[1].value
    argsAdd['colorGrado'] = miLista4.options[miLista4.selectedIndex].attributes[2].value
    this.setState({argsAdd});
  }  

  handleSelisoGrasa = () => {
    var miLista44 = document.getElementById("miLista44");
    const argsAdd = this.state.argsAdd
    argsAdd['isoGrasa'] = miLista44.options[miLista44.selectedIndex].text
    argsAdd['isoGrasaColor'] = miLista44.options[miLista44.selectedIndex].attributes[0].value
    argsAdd['isoGrasaTexto'] = miLista44.options[miLista44.selectedIndex].attributes[1].value

    this.setState({argsAdd});
  }  
  handleSeldescrAplicacion = () => {
    var miLista5 = document.getElementById("miLista5");
    const argsAdd = this.state.argsAdd
    argsAdd['descrAplicacion'] = miLista5.options[miLista5.selectedIndex].text
    this.setState({argsAdd});
  }  

  handleSelmetalicos = () => {
    var miLista6 = document.getElementById("miLista6");
    const argsAdd = this.state.argsAdd
    argsAdd['metalicos'] = miLista6.options[miLista6.selectedIndex].text
    this.setState({argsAdd});
  }  

  handleSelSiNo = (ev, nameLista) => {
    var miLista = document.getElementById(nameLista);
    const argsAdd = this.state.argsAdd
    if (nameLista==='miLista7'){
    argsAdd['nsf'] = miLista.options[miLista.selectedIndex].text
    }
    if (nameLista==='miLista8'){
      argsAdd['fda'] = miLista.options[miLista.selectedIndex].text
    }  
    if (nameLista==='miLista9'){
    argsAdd['biodegradables'] = miLista.options[miLista.selectedIndex].text
    }
    if (nameLista==='miLista10'){
      argsAdd['noToxico'] = miLista.options[miLista.selectedIndex].text
    }    
    if (nameLista==='miLista11'){
    argsAdd['ignifugo'] = miLista.options[miLista.selectedIndex].text
    }
    if (nameLista==='miLista12'){
      argsAdd['cumple'] = miLista.options[miLista.selectedIndex].text
    }    
    this.setState({argsAdd});
  }  

  handleSelcolorTexto = () => {
    var miLista2 = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['colorTexto'] = miLista2.options[miLista2.selectedIndex].text
    this.setState({argsAdd});
  }  

  handleSelsalud = () => {
    var miLista13 = document.getElementById("miLista13");
    const argsAdd = this.state.argsAdd
    argsAdd['salud'] = miLista13.options[miLista13.selectedIndex].text
    this.setState({argsAdd});
  } 

  handleSelinflamabilidad = () => {
    var miLista14 = document.getElementById("miLista14");
    const argsAdd = this.state.argsAdd
    argsAdd['inflamabilidad'] = miLista14.options[miLista14.selectedIndex].text
    this.setState({argsAdd});
  } 

  handleSelreactividad = () => {
    var miLista15 = document.getElementById("miLista15");
    const argsAdd = this.state.argsAdd
    argsAdd['reactividad'] = miLista15.options[miLista15.selectedIndex].text
    this.setState({argsAdd});
  } 

  handleSelblanco = () => {
    var miLista16 = document.getElementById("miLista16");
    const argsAdd = this.state.argsAdd
    argsAdd['blanco'] = miLista16.options[miLista16.selectedIndex].text
    this.setState({argsAdd});
  } 

  handleSelProcEjec = () => {
    var miLista6 = document.getElementById("miLista6");
    const argsAdd = this.state.argsAdd
    argsAdd['nombreArchivo'] = miLista6.options[miLista6.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  }
  
  handleSelInfoTarea = () => {
    var miLista6 = document.getElementById("miLista6");
    const argsAdd = this.state.argsAdd
    argsAdd['codInfoTarea'] = miLista6.options[miLista6.selectedIndex].attributes[0].value
    this.setState({argsAdd});
  }
  
  handleSeldescrLubricante = () => {
    var miLista = document.getElementById("miLista3");
    const argsAdd = this.state.argsAdd
    console.log(miLista.options[miLista.selectedIndex].text)
    argsAdd['descrLubricante'] = miLista.options[miLista.selectedIndex].text
    argsAdd['_id'] = miLista.options[miLista.selectedIndex].attributes[0].value
    argsAdd['tipoLub'] = miLista.options[miLista.selectedIndex].attributes[1].value
    console.log(argsAdd)
    this.setState({argsAdd});
  }

  handleSeldescrEmpresa = () => {
    var miLista = document.getElementById("miLista1");
    const argsAdd = this.state.argsAdd
    argsAdd['descrEmpresa'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  handleSeldescrUnidad = () => {
    var miLista = document.getElementById("miLista2");
    const argsAdd = this.state.argsAdd
    argsAdd['descrUnidad'] = miLista.options[miLista.selectedIndex].text
    this.setState({argsAdd});
  }

  idLista = async (ev, idLista)=>{
    this.setState({idLista: idLista})
    ev.preventDefault()
    this.estadosFalse()
    if (this.state.showMetodo) {
      this.setState({verMetodo: true})
    }   
    if (this.state.showTarea) {
      this.setState({verTarea: true})
    }        
    if (this.state.showFrecuencia) {
      this.setState({verFrecuencia: true})
    }        
    if (this.state.showAplicacion) {
      this.setState({verAplicacion: true})
    }        
    if (this.state.showGrado) {
      this.setState({verGrado: true})
    }
    if (this.state.showLubricante) {
      this.setState({verLubricante: true})
    }
    if (this.state.showProcEjec) {
      this.setState({verProcEjec: true})
    } 
    if (this.state.showInfoTarea) {
      this.setState({verInfoTarea: true})
    } 
    if (this.state.showDatCar) {
      this.setState({verDatCar: true})
    } 
    if (this.state.showStockLub) {
      this.setState({verStockLub: true})
    }
  };

  handleClickUpd = (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: true, permiteDelete: false, permiteClose: false})
  }

  handleClickDel = async (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: false, permiteDelete: true, permiteClose: false})
  }

  handleClickClo = async (ev) => {
    ev.preventDefault()
    this.setState({permiteUpdate: false, permiteDelete: false, permiteClose: true})
  }

  handleStockLub = async (ev, args)=>{
    let allUsuarios = await this.props.allUsuarios.allUsuarios
    let indexUsu = allUsuarios.findIndex( usuarios => usuarios.email===localStorage.getItem('userLogin') )
    let nombreUsu = allUsuarios[indexUsu].nombreUsuario
    let continuar=1
    let response = await this.props.fecha({
      variables: {}
    });
    const {fechaHoraHoy} = response.data.fecha
    const errors = [];
    if((args.descrLubricante==="Seleccionar..."||args.descrEmpresa==="Seleccionar..."||args.descrUnidad==="Seleccionar...") && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      if(!args.descrLubricante||args.descrLubricante==="Seleccionar..."){
        argsAdd['descrLubricante'] = "Seleccionar...";
        errors.push({path: 'descrLubricante', message: "Debe seleccionar el lubricante"});
      }
      if(!args.descrEmpresa||args.descrEmpresa==="Seleccionar..."){
        argsAdd['descrEmpresa'] = "Seleccionar...";
        errors.push({path: 'descrEmpresa', message: "Debe seleccionar la empresa"});
      }
      if(!args.descrUnidad||args.descrUnidad==="Seleccionar..."){
        argsAdd['descrUnidad'] = "Seleccionar...";
        errors.push({path: 'descrUnidad', message: "Debe seleccionar la unidad"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      let argsBuscar=""
      if(this.state.addStockLub){
        argsBuscar += `'_id': '${args._id}', 'descrEmpresa': '${args.descrEmpresa}'`
      
        let argsBuscarIt = {}
        argsBuscarIt = {tipoqry: `[${this.state.argsQuery5}, {$match: {${argsBuscar}}}]`}
        console.log(argsBuscarIt)
        let {data} = await this.props.allLubricanteRtes.refetch(argsBuscarIt)
        let regExiste = []
        regExiste = await data.allLubricanteRtes
        console.log(regExiste)
        if(regExiste.length>0){
          continuar=0
          errors.push({message: "La empresa ya tiene registro para este lubricante"});
          this.setState({errors})
          alert("!! La empresa ya tiene registro para este lubricante !!")
        }
      }

      if(continuar=1){
        if(this.state.addStockLub){
          if(errors.length!==0){
            this.setState({errorAdd: errors})
          }else{
            const argsUpd = {
              "_id": args._id,
              "tipoAct": "CrearStock",
              "descrEmpresa": args.descrEmpresa,
              "descrUnidad": args.descrUnidad,
              "existencia": parseFloat(args.existencia),
              "minimo": parseFloat(args.minimo),
              "usuarioAct": nombreUsu,
              "fechaAct": fechaHoraHoy,
            }
            console.log(argsUpd)
            response = await this.props.editLubricante({
              variables: argsUpd
            });
            const {errors, success} = response.data.editLubricante;
            if (!success){
              console.log(errors)
              this.setState({errorAdd: errors})
            }else{
              var descrLubricante = document.getElementById("miLista3");
              descrLubricante.options.selectedIndex = 0        
              var descrEmpresa = document.getElementById("miLista1");
              descrEmpresa.options.selectedIndex = 0 
              var descrUnidad = document.getElementById("miLista2");
              descrUnidad.options.selectedIndex = 0 
              var existencia = document.getElementById("existencia");
              existencia.value = 0
              var minimo = document.getElementById("minimo");
              minimo.value = 0
              this.setState({errorAdd: []})
              this.setState({argsAdd: {}})
              // this.setState({pruebaLAdd})
              console.log(errors)
            }
          }
        }else{
          if(this.state.permiteUpdate){
            console.log(args)
            const argsUpd = {
              "_id": args._id,
              "descrLubricante": args.descrLubricante,
              "tipoAct": "EditarStock",
              "descrEmpresa": args.descrEmpresa,
              "existencia": parseFloat(args.existencia),
              "minimo": parseFloat(args.minimo),
              "descrUnidad": args.descrUnidad,
              "usuarioAct": nombreUsu,
              "fechaAct": fechaHoraHoy, 
            }
            console.log(argsUpd)
            const response = await this.props.editLubricante({
              variables: argsUpd
            });
            const {errors, success} = response.data.editLubricante;
            if (!success){
              this.setState({errorAdd: errors})
            }else{
              this.estadosFalse()
              this.setState({showStockLub: true})
              // this.setState({pruebaLAdd})
            }
          }
          if(this.state.permiteDelete){
            const argsDel = {
              "_id": args._id,
              "descrLubricante": args.descrLubricante,
              "tipoAct": "EliminarStock",
              "descrEmpresa": args.descrEmpresa,
            }
            console.log(argsDel)

            const response = await this.props.editLubricante({
              variables: argsDel
            });
            const {errors, success} = response.data.editLubricante;
            if (!success){
              this.setState({errorAdd: errors})
            }else{
              this.estadosFalse()
              this.setState({showStockLub: true})
            }
          }
        }
      }
    }
  }

  handleDatCar = async (ev, argsDocum) => {
    if((!argsDocum.descrMetodo||argsDocum.descrMetodo==="Seleccionar..."||
        !argsDocum.descrTarea||argsDocum.descrTarea==="Seleccionar...") && !this.state.permiteDelete){
      const argsAdd = this.state.argsAdd
      const errors = [];
      if(!argsDocum.descrMetodo||argsDocum.descrMetodo==="Seleccionar..."){
        argsAdd['descrMetodo'] = "Seleccionar...";
        errors.push({path: 'descrMetodo', message: "Debe seleccionar el Método"});
      }
      if(!argsDocum.descrTarea||argsDocum.descrTarea==="Seleccionar..."){
        argsAdd['descrTarea'] = "Seleccionar...";
        errors.push({path: 'descrTarea', message: "Debe seleccionar la Tarea"});
      }
      this.setState({argsAdd});
      this.setState({errorAdd: errors})
    }else{
      if(this.state.permiteUpdate||this.state.permiteDelete){
        var miLista6 = document.getElementById("miLista6");

        let argsPl = {}, argsProg = {}
        let addColeccProg = [], addColeccPl = []
        let descrMetodo = argsDocum.descrMetodo==='Seleccionar...'?'':argsDocum.descrMetodo
        let descrTarea = argsDocum.descrTarea==='Seleccionar...'?'':argsDocum.descrTarea
        let codProcedimiento = argsDocum.codProcedimiento==='Seleccionar...'?'':argsDocum.codProcedimiento
        let nombreArchivo = argsDocum.codProcedimiento==='Seleccionar...'?'':miLista6.options[miLista6.selectedIndex].attributes[0].value

        argsProg['consecutivo'] = argsDocum.consecutivo
        argsProg['descrMetodo'] = descrMetodo
        argsProg['descrTarea'] = descrTarea
        argsProg['cantidad'] = argsDocum.cantidad
        argsProg['puntosLub'] = argsDocum.puntosLub
        argsProg['minutos'] = argsDocum.minutos
        argsProg['descrFrecuencia'] = argsDocum.descrFrecuencia
        argsProg['descrFrecuenciaPre'] = argsDocum.descrFrecuenciaPre
        argsProg['fechaProx'] = argsDocum.fechaProx?argsDocum.fechaProx:null
        argsProg['codProcedimiento'] = codProcedimiento
        argsProg['nombreArchivo'] = nombreArchivo

        addColeccProg.push(argsProg)
        argsProg = {}

        argsPl['descrEmpresa'] = argsDocum.descrEmpresa
        argsPl['descrPlanta'] = argsDocum.descrPlanta
        argsPl['descrSeccion'] = argsDocum.descrSeccion
        argsPl['descrEquipo'] = argsDocum.descrEquipo
        argsPl['descrComponente'] = argsDocum.descrComponente
        argsPl['descrMecanismo'] = argsDocum.descrMecanismo
        argsPl['descrMetodo'] = descrMetodo
        argsPl['descrTarea'] = descrTarea
        argsPl['descrMetodoAnt'] = descrMetodo
        argsPl['descrTareaAnt'] = descrTarea

        argsPl['programacion'] = addColeccProg
        if(this.state.permiteUpdate){
          argsPl['tipoAct'] = "EditarProgramacion"
        }else{
          argsPl['tipoAct'] = "EliminarProgramacion"
        }
        
        addColeccPl.push(argsPl)

        let updColeccProg = [], updColeccProg1 = []
        for(let iii=0; iii<addColeccPl.length; iii++){
          updColeccProg.push(addColeccPl[iii])
        }
        updColeccProg1.push({planta: updColeccProg})

        let numDocCRUD = 0
        let totDocCRUD = 1
        let argsCrud = []
        let crudColecc = []
        for(let iii=0; iii<totDocCRUD; iii++){
          argsCrud.push({ctrlCampo: 'NO_CRUD'})
        }
        for(let iii=0; iii<totDocCRUD; iii++){
          crudColecc.push(this.props.editPlantaEstructura)
        }

        argsCrud[numDocCRUD] = updColeccProg1[0]
        argsCrud[numDocCRUD]['ctrlCampo'] = 'CRUD'
        argsCrud[numDocCRUD]['ctrl_id'] = 'NO_ID'
        crudColecc[numDocCRUD] = this.props.editPlantaEstructura
    
        console.log(argsCrud)
        await this.updColecc(crudColecc, argsCrud, totDocCRUD)

        this.props.allPlantaRtes.refetch()
        this.estadosFalse()
        this.setState({showDatCar: true})
      }
    }
  }

  componentDidUpdate(prevProps, prevState){
    if(this.state.argsBuscEstruct.descrEmpresa){
//Para actualizar los criterios de busqueda cuando se hace cambia de pantalla y regresa
      if(this.state.argsBuscEstruct.descrEmpresa){
        var descrEmpresa = document.getElementById("miLista");
        if(descrEmpresa){descrEmpresa.value = this.state.argsBuscEstruct.descrEmpresa}
      }

      if(this.state.argsBuscEstruct.numDocum){
        var numDocum = document.getElementById("numDocum");
        if(numDocum){numDocum.value = this.state.argsBuscEstruct.numDocum}
      }

      if(this.state.argsBuscEstruct.descrPlanta){
        var descrPlanta = document.getElementById("descrPlanta");
        if(descrPlanta){descrPlanta.value = this.state.argsBuscEstruct.descrPlanta}
      }
      if(this.state.argsBuscEstruct.descrSeccion){
        var descrSeccion = document.getElementById("descrSeccion");
        if(descrSeccion){descrSeccion.value = this.state.argsBuscEstruct.descrSeccion}
      }
      if(this.state.argsBuscEstruct.descrEquipo){
        var descrEquipo = document.getElementById("descrEquipo");
        if(descrEquipo){descrEquipo.value = this.state.argsBuscEstruct.descrEquipo}
      }
      if(this.state.argsBuscEstruct.descrComponente){
        var descrComponente = document.getElementById("descrComponente");
        if(descrComponente){descrComponente.value = this.state.argsBuscEstruct.descrComponente}
      }
      if(this.state.argsBuscEstruct.descrMecanismo){
        var descrMecanismo = document.getElementById("descrMecanismo");
        if(descrMecanismo){descrMecanismo.value = this.state.argsBuscEstruct.descrMecanismo}
      }
//FIN Para actualizar los criterios de busqueda cuando se hace cambia de pantalla y regresa
    }
    if(((this.state.showDatCar!==prevState.showDatCar&&prevState.showDatCar)||
        (this.state.showGenRot!==prevState.showGenRot&&prevState.showGenRot)||
        (this.state.showAsImEq!==prevState.showAsImEq&&prevState.showAsImEq)||
        (this.state.showAsImSecc!==prevState.showAsImSecc&&prevState.showAsImSecc)||
        (this.state.showImprCL!==prevState.showImprCL&&prevState.showImprCL)||
        (this.state.showPdfEq!==prevState.showPdfEq&&prevState.showPdfEq))&&
        !prevState.verDatCar&&!this.state.verDatCar){
      let argsBuscEstruct = this.state.argsBuscEstruct
      argsBuscEstruct.descrEmpresa = localStorage.getItem('Empresa')==="Todas..."?"Seleccionar Empresa...":localStorage.getItem('Empresa')
      if(argsBuscEstruct.descrPlanta){
        delete argsBuscEstruct.descrPlanta
      }
      if(argsBuscEstruct.descrSeccion){
        delete argsBuscEstruct.descrSeccion
      }
      if(argsBuscEstruct.descrEquipo){
        delete argsBuscEstruct.descrEquipo
      }
      if(argsBuscEstruct.descrComponente){
        delete argsBuscEstruct.descrComponente
      }
      if(argsBuscEstruct.descrMecanismo){
        delete argsBuscEstruct.descrMecanismo 
      }
    }
    if((this.state.argsBuscEstruct!==prevState.argsBuscEstruct)||
        (this.props.allPlantaRtes.allPlantaRtes&&this.props.allPlantaRtes.allPlantaRtes.length===0)||
        (this.state.showDatCar!==prevState.showDatCar)||(this.state.showGenRot!==prevState.showGenRot)||
        (this.state.showAsImEq!==prevState.showAsImEq)||(this.state.showAsImSecc!==prevState.showAsImSecc)||(this.state.showImprCL!==prevState.showImprCL)||(this.state.showPdfEq!==prevState.showPdfEq)){
      let argsBuscar=""
      argsBuscar += `'descrEmpresa': '${this.state.argsBuscEstruct.descrEmpresa}', 'descrSeccion': {$ne: 'Linea Placa Yeso'}`
      if(this.state.argsBuscEstruct.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.state.argsBuscEstruct.descrPlanta}/i`
      }
      if(this.state.argsBuscEstruct.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.state.argsBuscEstruct.descrSeccion}/i`
      }
      if(this.state.argsBuscEstruct.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.state.argsBuscEstruct.descrEquipo}/i`
      }
      if(this.state.argsBuscEstruct.descrComponente){
        argsBuscar += `, 'descrComponente': /${this.state.argsBuscEstruct.descrComponente}/i`
      }
      if(this.state.argsBuscEstruct.descrMecanismo){
        argsBuscar += `, 'descrMecanismo': /${this.state.argsBuscEstruct.descrMecanismo}/i`
      }
      let argsBuscarPl = {}
      let argsQuery = this.state.argsQuery
      let sort = ''
      if(this.state.showImprCL){
        argsQuery = this.state.argsQuery1
      }
      
      if(this.state.showGenRot){
        argsQuery = this.state.argsQuery3
        sort = "{$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1, descrMecanismo: 1}}"
      }
      if(this.state.showAsImEq){
        argsQuery = this.state.argsQuery2
      }
      if(this.state.showAsImSecc){
        argsQuery = this.state.argsQuery6
      }
      if(this.state.showImprCL||this.state.showPdfEq){
//OJOOO para ordenar la carta por descrPlanta, numCarta, consecutivo, ...  se debe tener cuidado de que el
//consecutivo este sin saltos dentro del mismo equipo
//por eso se cambia el ordenamiento y se pone comentario como estaba
        // sort = "{$sort: {descrPlanta: 1, numCarta: 1, consecutivo: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1, descrMecanismo: 1}}"
        sort = "{$sort: {descrPlanta: 1, numCarta: 1, consecutivo: 1}}"
        // sort = "{$sort: {descrPlanta: 1, numCarta: 1, descrSeccion: 1, descrEquipo: 1, descrComponente: 1, consecutivo: 1, descrMecanismo: 1}}"
      }
      if(this.state.argsBuscEstruct.numDocum){
        argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}},
          ${sort},
          {$limit: ${this.state.argsBuscEstruct.numDocum}}]`}
      }else{
        if(this.state.showAsImEq||this.state.showAsImSecc){
          argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}}]`}
        }else{
          argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}},
            ${sort}]`}
        }
      }

      this.props.allPlantaRtes.refetch(argsBuscarPl)
      if(this.state.showImprCL||this.state.showPdfEq){
        argsQuery = this.state.argsQuery2
        argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}},
          {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1, ordenImagen: 1}}]`}
        this.props.allPlantaRtes1.refetch(argsBuscarPl)
      }
      if(this.state.showGenRot){
        argsQuery = this.state.argsQuery4
        argsBuscarPl = {tipoqry: `[${argsQuery}, {$match: {${argsBuscar}}},
          {$sort: {descrPlanta: 1, descrSeccion: 1, descrEquipo: 1}}]`}
        this.props.allPlantaRtesGenRot.refetch(argsBuscarPl)
      }
    }
  }

  render(){
    const {showCar, showMetodo, addMetodo, verMetodo, showTarea, addTarea, verTarea, 
          showFrecuencia, addFrecuencia, verFrecuencia, 
          showAplicacion, addAplicacion, verAplicacion, 
          showGrado, addGrado, verGrado, 
          showLubricante, addLubricante, verLubricante, showStockLub, addStockLub, verStockLub,
          showProcEjec, addProcEjec, verProcEjec, showInfoTarea, addInfoTarea, verInfoTarea,
          showDatCar, verDatCar, showSimRot, showGenRot, showAsImEq, showAsImSecc, showImprCL, showAnexos, showPdfEq,
          permiteUpdate, permiteDelete, permiteClose,
          argsAdd, errorAdd, argsBuscEstruct, idLista, argsBusc, argsBuscGrado, argsBuscar, argsBuscStock, argsBuscLub} = this.state;

      let lista = []
      let lista1 = []
      let lista2 = []
      let lista3 = []
      let lista4 = []
      let lista6 = []
      let lista7 = []
      let listaR = []
      let descrEmpresaUA=localStorage.getItem('Empresa')

      if (this.state.showMetodo) {
        if(this.props.allMetodo.allMetodo){lista = this.props.allMetodo.allMetodo}
      }
      if (this.state.showTarea) {
        if(this.props.allTarea.allTarea){lista = this.props.allTarea.allTarea}
      }
      if (this.state.showFrecuencia) {
        if(this.props.allFrecuencia.allFrecuencia){lista = this.props.allFrecuencia.allFrecuencia}
      }
      if (this.state.addFrecuencia || this.state.verFrecuencia) {
        if(this.props.allUnidad.allUnidad){lista = this.props.allUnidad.allUnidad}
      }
      if (this.state.showAplicacion) {
        if(this.props.allAplicacion.allAplicacion){lista = this.props.allAplicacion.allAplicacion}
      }      
      if (this.state.showGrado) {
        if(this.props.allGrado.allGrado){lista = this.props.allGrado.allGrado}
      }      
      if (this.state.showLubricante) {
        if(this.props.allLubricante.allLubricante){lista = this.props.allLubricante.allLubricante}
        console.log(lista)
      }
      if (this.state.showStockLub) {
        if(this.props.allLubricanteRtes.allLubricanteRtes){lista = this.props.allLubricanteRtes.allLubricanteRtes}
      }
      if (this.state.addStockLub || this.state.verStockLub) {
        if(this.props.allLubricante.allLubricante){lista = this.props.allLubricante.allLubricante}
        if(this.props.allEmpresa.allEmpresa){lista1 = this.props.allEmpresa.allEmpresa}
        if(this.props.allUnidad.allUnidad){lista2 = this.props.allUnidad.allUnidad}
      }
      if (this.state.showProcEjec) {
        if(this.props.allProcEjec.allProcEjec){lista = this.props.allProcEjec.allProcEjec}
      }
      if (this.state.showInfoTarea) {
        console.log(this.props.allInfoTarea.allInfoTarea)
        if(this.props.allInfoTarea.allInfoTarea){lista = this.props.allInfoTarea.allInfoTarea}
        console.log(lista)
      }
      if (this.state.addProcEjec||this.state.verProcEjec) {
      }
      if (this.state.addLubricante || this.state.verLubricante) {
        if(this.props.allGrado.allGrado){lista1 = this.props.allGrado.allGrado}
      }
      if (this.state.showSimRot) {
        if(this.props.allAplicacion.allAplicacion){lista = this.props.allAplicacion.allAplicacion}
        if(this.props.allGrado.allGrado){lista1 = this.props.allGrado.allGrado}
        if(this.props.allFrecuencia.allFrecuencia){lista2 = this.props.allFrecuencia.allFrecuencia}
      } 
      if (this.state.showDatCar||this.state.showGenRot||this.state.showAsImEq||this.state.showAsImSecc||this.state.showImprCL||this.state.showPdfEq) {
        if(this.props.allPlantaRtes.allPlantaRtes){lista = this.props.allPlantaRtes.allPlantaRtes}
        if(this.props.allPlantaRtesGenRot.allPlantaRtes){listaR = this.props.allPlantaRtesGenRot.allPlantaRtes}
        lista1.push({descrEmpresa: "Seleccionar Empresa...", logo: "", _id: 0})
        if(this.props.allEmpresa.allEmpresa){
          this.props.allEmpresa.allEmpresa.forEach((elemento, ii) => {
            if(descrEmpresaUA==="Todas..."){
              lista1.push({descrEmpresa: elemento.descrEmpresa, logo: elemento.logo, _id: ii+1})
            }else{
              if(descrEmpresaUA===elemento.descrEmpresa){
                lista1.push({descrEmpresa: elemento.descrEmpresa, logo: elemento.logo, _id: ii+1})
              }
            }
          })
        } 
        if(this.state.showImprCL||this.state.showPdfEq){ 
          if(this.props.allPlantaRtes1.allPlantaRtes){
            this.props.allPlantaRtes1.allPlantaRtes.forEach((elemento, ii) => {
              if(elemento.nombreImagen!==null){
                lista2.push(elemento)
              }
            })
          }
        }  
      }
      if (this.state.verDatCar) {
        if(this.props.allLubricante.allLubricante){lista = this.props.allLubricante.allLubricante}
        if(this.props.allMetodo.allMetodo){lista1 = this.props.allMetodo.allMetodo}
        if(this.props.allTarea.allTarea){lista2 = this.props.allTarea.allTarea}
        if(this.props.allUnidad.allUnidad){lista3 = this.props.allUnidad.allUnidad}
        if(this.props.allFrecuencia.allFrecuencia){lista4 = this.props.allFrecuencia.allFrecuencia}
        if(this.props.allProcEjec.allProcEjec){lista6 = this.props.allProcEjec.allProcEjec}
        if(this.props.allInfoTarea.allInfoTarea){lista7 = this.props.allInfoTarea.allInfoTarea}
      }  

    return (
      <div>
        <div className="ui two column stackable grid">
          <div className="column" style={this.props.styles.boxIzq}>
            {showCar && <HomeCar1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                        handleClickSel13={this.showMetodo} handleClickSel14={this.showTarea} 
                        handleClickSel15={this.showFrecuencia} handleClickSel16={this.showAplicacion}
                        handleClickSel17={this.showGrado} handleClickSel18={this.showLubricante}
                        handleClickSel7={this.showProcEjec} handleClickSel29={this.showInfoTarea} 
                        handleClickSel24={this.showStockLub} handleClickSel20={this.showGenRot}
                        handleClickSel21={this.showImprCL} handleClickSel23={this.showAsImEq} handleClickSel19={this.showPdfEq}
                        handleClickSel26={this.showAsImSecc} handleClickSel25={this.showAnexos}/>} 

            {showMetodo && <ConfMetodo1 styles={this.props.styles} handleClickRegr={this.showCar}/>}
            {addMetodo && <AddMetodo1 styles={this.props.styles} handleClickRegr={this.showMetodo}/>}
            {verMetodo && <VerMetodo1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showMetodo} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showTarea && <ConfTarea1 styles={this.props.styles} handleClickRegr={this.showCar}/>}
            {addTarea && <AddTarea1 styles={this.props.styles} handleClickRegr={this.showTarea}/>}
            {verTarea && <VerTarea1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showTarea} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showFrecuencia && <ConfFrecuencia1 styles={this.props.styles} handleClickRegr={this.showCar}/>}
            {addFrecuencia && <AddFrecuencia1 styles={this.props.styles} handleClickRegr={this.showFrecuencia}/>}
            {verFrecuencia && <VerFrecuencia1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showFrecuencia} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showAplicacion && <ConfAplicacion1 styles={this.props.styles} handleClickRegr={this.showCar}/>}
            {addAplicacion && <AddAplicacion1 styles={this.props.styles} handleClickRegr={this.showAplicacion}/>}
            {verAplicacion && <VerAplicacion1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showAplicacion} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showGrado && <ConfGrado1 styles={this.props.styles} handleClickRegr={this.showCar} 
                handleChange={this.handleChangeBuscGrado} handleSubmit={this.handleBuscGrado}
                args={argsBuscar}/>}
            {addGrado && <AddGrado1 styles={this.props.styles} handleClickRegr={this.showGrado}/>}
            {verGrado && <VerGrado1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showGrado} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showLubricante && <ConfLubricante1 styles={this.props.styles} handleClickRegr={this.showCar}
                handleSubmit={this.handleBuscLub} handleChange={this.handleChangeBuscLub} args={argsBuscar}/>}
            {addLubricante && <AddLubricante1 styles={this.props.styles} handleClickRegr={this.showLubricante}/>}
            {verLubricante && <VerLubricante1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showLubricante} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showStockLub && <CarStockLub1 styles={this.props.styles} handleClickRegr={this.showCar}
                handleChange={this.handleChangeBuscEstruct} handleSubmit={this.handleBuscStock}
                args={argsBuscar}/>}
            {addStockLub && <AddStockLub1 styles={this.props.styles} handleClickRegr={this.showStockLub}/>}
            {verStockLub && <VerStockLub1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showStockLub} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>} 
            {showProcEjec && <ConfProcEjec1 styles={this.props.styles} handleClickRegr={this.showCar}/>}
            {addProcEjec && <AddProcEjec1 styles={this.props.styles} handleClickRegr={this.showProcEjec}/>}
            {verProcEjec && <VerProcEjec1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showProcEjec} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showInfoTarea && <ConfInfoTarea1 styles={this.props.styles} handleClickRegr={this.showCar}/>}
            {addInfoTarea && <AddInfoTarea1 styles={this.props.styles} handleClickRegr={this.showInfoTarea}/>}
            {verInfoTarea && <VerInfoTarea1 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClickRegr={this.showInfoTarea} handleClickUpd={this.handleClickUpd} 
                handleClickDel={this.handleClickDel}/>}

            {showDatCar && <ConfDatCar1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                handleChange={this.handleChangeBuscEstruct} handleSubmit={this.handleBuscEstruct}
                args={argsBuscEstruct} handleClickRegr={this.showCar}/>}
            {verDatCar && <VerDatCar1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                    handleClickRegr={this.showDatCar}
                    handleClickUpd={this.handleClickUpd} handleClickDel={this.handleClickDel}/>}

            {showSimRot && <ConfSimRot1 styles={this.props.styles} handleClickRegr={this.showCar}/>}

            {showGenRot && <ConfGenRot1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                handleChange={this.handleChangeBuscEstruct} handleSubmit={this.handleBuscEstruct}
                args={argsBuscEstruct} handleClickRegr={this.showCar}/>}

            {showAsImEq && <ConfAsImEq1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                handleChange={this.handleChangeBuscEstruct} handleSubmit={this.handleBuscEstruct}
                args={argsBuscEstruct} handleClickRegr={this.showCar}/>}
            {showAsImSecc && <ConfAsImSecc1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                handleChange={this.handleChangeBuscEstruct} handleSubmit={this.handleBuscEstruct}
                args={argsBuscEstruct} handleClickRegr={this.showCar}/>}

            {showImprCL && <ConfImprCL1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                handleChange={this.handleChangeBuscEstruct} handleSubmit={this.handleBuscEstruct}
                args={argsBuscEstruct} handleClickRegr={this.showCar}/>}
            {showAnexos && <CarAnexos1 styles={this.props.styles} handleClickRegr={this.showCar}/>}
            {showPdfEq && <CarPdfEq1 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                handleChange={this.handleChangeBuscEstruct} handleSubmit={this.handleBuscEstruct}
                args={argsBuscEstruct} handleClickRegr={this.showCar}/>}
          </div>

          <div className="column" style={this.props.styles.boxDer}>
            {showCar && <HomeCar2 styles={this.props.styles}/>}

            {showMetodo && <ConfMetodo2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addMetodo} list={lista} handleClickidLista={this.idLista}/>}
            {addMetodo && <AddMetodo2 styles={this.props.styles} handleLista={this.handleSeltipoLub} 
                handleSubmit={this.handleMetodo} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verMetodo && <VerMetodo2 styles={this.props.styles} handleSubmit={this.handleMetodo} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showTarea && <ConfTarea2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addTarea} list={lista} handleClickidLista={this.idLista}/>}
            {addTarea && <AddTarea2 styles={this.props.styles} handleLista={this.handleSeltipoLub} 
                handleSubmit={this.handleTarea} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verTarea && <VerTarea2 styles={this.props.styles} handleSubmit={this.handleTarea} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showFrecuencia && <ConfFrecuencia2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addFrecuencia} list={lista} handleClickidLista={this.idLista}/>}
            {addFrecuencia && <AddFrecuencia2 styles={this.props.styles} list={lista} 
                handleLista={this.handleSeltipoFrecuencia} handleLista1={this.handleSelabrevUnidad}
                handleSubmit={this.handleFrecuencia} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verFrecuencia && <VerFrecuencia2 styles={this.props.styles} list={lista} handleSubmit={this.handleFrecuencia} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showAplicacion && <ConfAplicacion2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addAplicacion} list={lista} handleClickidLista={this.idLista}/>}
            {addAplicacion && <AddAplicacion2 styles={this.props.styles} list={lista}  
                handleLista={this.handleSeltipoLub} handleLista1={this.handleSelsector} 
                handleSubmit={this.handleAplicacion} handleColor={this.handleColor}
                handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verAplicacion && <VerAplicacion2 styles={this.props.styles} list={lista} 
                handleSubmit={this.handleAplicacion} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showGrado && <ConfGrado2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addGrado} list={lista} handleClickidLista={this.idLista} 
                argsBuscGrado={argsBuscGrado} graSel={idLista.descrGrado}/>} 
            {addGrado && <AddGrado2 styles={this.props.styles} list={lista}  
                handleLista={this.handleSeltipoLub} handleLista1={this.handleSeltipoGrado} 
                handleLista6={this.handleSelaplisae} handleLista3={this.handleSelcatsae} 
                handleLista4={this.handleSelapisae} handleLista7={this.handleSelapisae2} 
                handleLista5={this.handleSelsector} handleColor={this.handleColor} 
                handleLista2={this.handleSelcolorTexto} 
                handleSubmit={this.handleGrado} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verGrado && <VerGrado2 styles={this.props.styles} list={lista} 
                handleSubmit={this.handleGrado} 
                args={argsAdd} errors={errorAdd} idLista={idLista} permiteUpdate={permiteUpdate} 
                permiteDelete={permiteDelete}/>}

            {showLubricante && <ConfLubricante2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addLubricante} list={lista} handleClickidLista={this.idLista} argsBuscLub={argsBuscLub}/>}
            {addLubricante && <AddLubricante2 styles={this.props.styles} list={lista} list1={lista1} list2={lista2} 
                handleLista2={this.handleSelclaseLub} handleLista1={this.handleSeltipoGrado} 
                handleLista={this.handleSeltipoLubri} handleLista3={this.handleSelcatLub} 
                handleLista4={this.handleSeldescrGrado} handleLista44={this.handleSelisoGrasa} 
                handleLista6={this.handleSelmetalicos} handleLista7={(ev, nameLista)=>this.handleSelSiNo(ev, nameLista)}
                handleLista9={this.handleSelsalud}
                handleLista10={this.handleSelinflamabilidad} handleLista11={this.handleSelreactividad}
                handleLista12={this.handleSelblanco}
                handleSubmit={this.handleLubricante} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verLubricante && <VerLubricante2 styles={this.props.styles} list1={lista1} 
                handleSubmit={this.handleLubricante} args={argsAdd} errors={errorAdd} idLista={idLista} 
                permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showStockLub && <CarStockLub2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addStockLub} handleClickidLista={this.idLista} argsBuscStock={argsBuscStock}/>}
            {addStockLub && <AddStockLub2 styles={this.props.styles} listL={lista} listE={lista1} listU={lista2}
                handleLista={this.handleSeldescrLubricante} handleLista1={this.handleSeldescrEmpresa} handleLista2={this.handleSeldescrUnidad}
                handleSubmit={this.handleStockLub} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verStockLub && <VerStockLub2 styles={this.props.styles} listL={lista} listE={lista1} listU={lista2} handleSubmit={this.handleStockLub} 
                args={argsAdd} errors={errorAdd} idLista={idLista} 
                permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showProcEjec && <ConfProcEjec2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addProcEjec} list={lista} handleClickidLista={this.idLista}/>}
            {addProcEjec && <AddProcEjec2 styles={this.props.styles} 
                handleSubmit={this.handleProcEjec} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verProcEjec && <VerProcEjec2 styles={this.props.styles} 
                handleSubmit={this.handleProcEjec} args={argsAdd} errors={errorAdd} idLista={idLista} 
                permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}
            
            {showInfoTarea && <ConfInfoTarea2 autorizacUA={this.props.autorizacUA} styles={this.props.styles} 
                handleClick={this.addInfoTarea} list={lista} handleClickidLista={this.idLista}/>}
            {addInfoTarea && <AddInfoTarea2 styles={this.props.styles} 
                handleSubmit={this.handleInfoTarea} handleChange={this.handleChange} args={argsAdd} errors={errorAdd} />}
            {verInfoTarea && <VerInfoTarea2 styles={this.props.styles} 
                handleSubmit={this.handleInfoTarea} args={argsAdd} errors={errorAdd} idLista={idLista} 
                permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showDatCar && <ConfDatCar2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                  list={lista} list1={lista1} handleClickidListaP={this.idLista}
                  handleChange={this.handleChangeBuscEstruct}/>}
            {verDatCar && <VerDatCar2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                  list={lista} list1={lista1} list2={lista2} list3={lista3} list4={lista4} list6={lista6}
                  errors={errorAdd} idLista={idLista}  
                  handleSubmit={this.handleDatCar} args={argsAdd} 
                  permiteUpdate={permiteUpdate} permiteDelete={permiteDelete}/>}

            {showSimRot && <ConfSimRot2 styles={this.props.styles} list={lista} list1={lista1} list2={lista2}/>}

            {showGenRot && <ConfGenRot2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                  list={lista} listR={listaR} list1={lista1} args={argsBuscEstruct} handleChange={this.handleChangeBuscEstruct}/>}

            {showAsImEq && <ConfAsImEq2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                  list={lista} list1={lista1} handleUpdAsImEq={this.handleUpdAsImEq}
                  handleElimAsImEq={this.handleElimAsImEq} args={argsBuscEstruct} 
                  handleChange={this.handleChangeBuscEstruct}/>}
            {showAsImSecc && <ConfAsImSecc2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                  list={lista} list1={lista1} handleUpdAsImSecc={this.handleUpdAsImSecc}
                  handleElimAsImSecc={this.handleElimAsImSecc} args={argsBuscEstruct} 
                  handleChange={this.handleChangeBuscEstruct}/>}

            {showImprCL && <ConfImprCL2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                  list={lista} list1={lista1} list2={lista2}
                  args={argsBuscEstruct} handleChange={this.handleChangeBuscEstruct}/>}
            {showPdfEq && <CarPdfEq2 autorizacUA={this.props.autorizacUA} styles={this.props.styles}
                  list={lista} list1={lista1} list2={lista2}
                  args={argsBuscEstruct} handleChange={this.handleChangeBuscEstruct}/>}      
            {showAnexos && <CarAnexos2 styles={this.props.styles}/>}          
          </div>
        </div>
      </div>
    )
  }
}

export default compose(
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}, {$limit : 100}]`}}}}),
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes1',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.query.allPlantaRtes, {name:'allPlantaRtesGenRot',
    options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  graphql(queries.query.allLubricanteRtes, {name:'allLubricanteRtes',
    options: (props) => {return {variables: {tipoqry: `[{$sort : {descrLubricante: 1, descrEmpresa: 1}}]`}}}}),
  
  graphql(queries.mutation.singleUpload, {name:'singleUpload'}),

  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),
  graphql(queries.query.allUsuarios, {name:'allUsuarios'}),
  graphql(queries.mutation.editPlantaEstructura, {name:'editPlantaEstructura'}),
  graphql(queries.mutation.editPlantaUpdSeccion, {name:'editPlantaUpdSeccion'}),

  graphql(queries.query.allMetodo, {name:'allMetodo'}),
  graphql(queries.mutation.createMetodo, {name:'createMetodo'}),
  graphql(queries.mutation.editMetodo, {name:'editMetodo'}),
  graphql(queries.mutation.deleteMetodo, {name:'deleteMetodo'}),

  graphql(queries.query.allTarea, {name:'allTarea'}),
  graphql(queries.mutation.createTarea, {name:'createTarea'}),
  graphql(queries.mutation.editTarea, {name:'editTarea'}),
  graphql(queries.mutation.deleteTarea, {name:'deleteTarea'}),

  graphql(queries.query.allFrecuencia, {name:'allFrecuencia'}),
  graphql(queries.mutation.createFrecuencia, {name:'createFrecuencia'}),
  graphql(queries.mutation.editFrecuencia, {name:'editFrecuencia'}),
  graphql(queries.mutation.deleteFrecuencia, {name:'deleteFrecuencia'}),
  graphql(queries.query.allUnidad, {name:'allUnidad'}),

  graphql(queries.query.allAplicacion, {name:'allAplicacion'}),
  graphql(queries.mutation.createAplicacion, {name:'createAplicacion'}),
  graphql(queries.mutation.editAplicacion, {name:'editAplicacion'}),
  graphql(queries.mutation.deleteAplicacion, {name:'deleteAplicacion'}),

  graphql(queries.query.allGrado, {name:'allGrado'}),
  graphql(queries.mutation.createGrado, {name:'createGrado'}),
  graphql(queries.mutation.editGrado, {name:'editGrado'}),
  graphql(queries.mutation.deleteGrado, {name:'deleteGrado'}),

  graphql(queries.query.allLubricante, {name:'allLubricante'}),
  graphql(queries.mutation.createLubricante, {name:'createLubricante'}),
  graphql(queries.mutation.editLubricante, {name:'editLubricante'}),
  graphql(queries.mutation.deleteLubricante, {name:'deleteLubricante'}),

  graphql(queries.query.allProcEjec, {name:'allProcEjec'}),
  graphql(queries.mutation.createProcEjec, {name:'createProcEjec'}),
  graphql(queries.mutation.editProcEjec, {name:'editProcEjec'}),
  graphql(queries.mutation.deleteProcEjec, {name:'deleteProcEjec'}),

  graphql(queries.query.allInfoTarea, {name:'allInfoTarea'}),
  graphql(queries.mutation.createInfoTarea, {name:'createInfoTarea'}),
  graphql(queries.mutation.editInfoTarea, {name:'editInfoTarea'}),
  graphql(queries.mutation.deleteInfoTarea, {name:'deleteInfoTarea'}),

  graphql(queries.mutation.editSeqfindOneAndUpdate, {name:'editSeqfindOneAndUpdate'}),
  graphql(queries.mutation.fecha, {name:'fecha'}),
)(HomeCar)
